<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-dropdown right
                          no-caret
                          variant="link"
                          boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover.bottom
                          title="Agregar Comprobante">
                <template #button-content>
                  <AppIcon name="add" label="Agregar Comprobante" />
                </template>
                <b-dropdown-item @click="add('factura')"><AppIcon name="add" /> Factura <small class="text-muted ml-1">(CTRL+SHIFT+F)</small></b-dropdown-item>
                <b-dropdown-item @click="add('notadebito')"><AppIcon name="add" /> Nota de Débito <small class="text-muted ml-1">(CTRL+SHIFT+D)</small></b-dropdown-item>
                <b-dropdown-item @click="add('notacredito')"><AppIcon name="add" /> Nota de Crédito <small class="text-muted ml-1">(CTRL+SHIFT+C)</small></b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="add('notacredito', 'discounts')" v-if="access.elements.createCreditNoteDiscounts"><AppIcon name="percent" /> Descuentos (NC)</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 155px; max-width: 210px;">
              <label class="filter-label">Tipo de Comprobante</label>
              <b-form-select size="sm" v-model="filters.types_vouchers_id" :options="filterVoucherTypeOptions"></b-form-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 130px; max-width: 165px;">
              <label class="filter-label">Nº Comprobante</label>
              <b-form-input type="number" size="sm" placeholder="Buscar por Nº" v-model="filters.number" v-on:keyup.enter.native="filterSales()"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;">
              <label class="filter-label">Estado</label>
              <v-select :options="arr.filters.status_imputation" v-model="filters.status_imputation" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;">
              <label class="filter-label">Punto de Venta</label>
              <v-select :options="arr.filters.points_sales" v-model="filters.points_sales" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 260px; max-width: 380px;">
              <label class="filter-label">Clientes</label>
              <v-select :options="arr.filters.customers" v-model="filters.customers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;" v-if="moduleSellersActive">
              <label class="filter-label">Vendedores</label>
              <v-select :options="arr.filters.sellers" v-model="filters.sellers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 300px;" v-if="showShipping">
              <label class="filter-label">Transportistas</label>
              <v-select :options="arr.filters.shipping" v-model="filters.shipping" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterSales()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card no-body>
            <b-tabs pills card :vertical="!isMobileViewport" class="crud-sales-view-tabs">
              <b-tab>
                <template #title>
                  <AppIcon name="reports" label="Ventas" font-scale="1.5" />
                </template>
                <b-card-text>
                  <b-card>
                    <b-row>
                      <b-col sm="12">
                        <b-table class="app-table"
                                ref="table"
                                responsive
                                :stacked="isMobileViewport ? 'md' : false"
                                sticky-header="60vh"
                                :hover="true"
                                :small="true"
                                :fixed="true"
                                :items="table.items"
                                :fields="table.fields"
                                :current-page="table.currentPage"
                                :per-page="table.perPage"
                                @row-clicked="onRowClicked"
                                :tbody-tr-class="rowClass"
                                :busy="table.isBusy"
                                v-if="table.items.length || table.isBusy">

                            <template v-slot:table-colgroup="scope">
                              <col
                                v-for="field in scope.fields"
                                :key="field.key"
                                :style="{ width: field.width }"
                              >
                            </template>

                            <template v-slot:table-busy>
                              <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                              </div>
                            </template>

                            <template v-slot:cell(business)="data">
                              {{data.item.point_sale.business.reference}}
                            </template>

                            <template v-slot:cell(id)="data">
                              <div v-if="data.item.type_voucher && data.item.point_sale"
                                  class="text-nowrap"
                                  :class="{'text-danger font-weight-bold':(data.item.afip_error && !data.item.point_sale.nd), 'text-success font-weight-bold':data.item.afip && data.item.afip_qr && !data.item.point_sale.nd}"
                                  v-b-tooltip.hover
                                  :title="data.item.afip_error">
                                {{data.item.type_voucher.name}} {{data.item.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.number.toString().padStart(8,'0')}}
                              </div>
                            </template>

                            <template v-slot:cell(date)="data">
                              {{moment(data.item.date).format('DD/MM/YYYY')}}
                            </template>

                            <template v-slot:cell(date_expiration)="data">
                              {{moment(data.item.date_expiration).format('DD/MM/YYYY')}}
                            </template>

                            <template v-slot:cell(sellers_id)="data">
                              <span v-if="data.item.sellers_id" v-b-tooltip.hover :title="'VENDEDOR: ' + data.item.seller.staff.name">
                                <b-avatar :src="data.item.seller.staff.image"
                                          v-if="data.item.seller.staff.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.seller.staff.name).text"
                                          :style="avatarFromName(data.item.seller.staff.name).style">
                                </b-avatar>
                                <span v-if="isMobileViewport" class="ml-2">{{data.item.seller.staff.name}}</span>
                              </span>
                            </template>

                            <template v-slot:cell(staff_id)="data">
                              <span v-if="data.item.staff_id" v-b-tooltip.hover :title="'STAFF: ' + data.item.staff.name">
                                <b-avatar :src="data.item.staff.image"
                                          v-if="data.item.staff.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.staff.name).text"
                                          :style="avatarFromName(data.item.staff.name).style">
                                </b-avatar>
                                <span v-if="isMobileViewport" class="ml-2">{{data.item.staff.name}}</span>
                              </span>
                            </template>

                            <template v-slot:cell(customers_id)="data">
                              <div v-if="data.item.customer">
                                <b-avatar :src="data.item.customer.image"
                                          v-if="data.item.customer.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.customer.name).text"
                                          :style="avatarFromName(data.item.customer.name).style">
                                </b-avatar>
                                &nbsp;<b>{{data.item.customer.name}}</b>

                                <AppIcon name="circle-fill"
                                        v-if="!data.item.customer.active"
                                        class="ml-2 text-danger"
                                        v-b-tooltip.hover
                                        title="Cliente INACTIVO" />

                                <AppIcon name="person-lines-fill"
                                        v-if="data.item.afip_customer_identification"
                                        class="ml-2"
                                        v-b-tooltip.hover
                                        :title="'NOMBRE:' + data.item.afip_customer_identification.name + ' - DNI:' + data.item.afip_customer_identification.document_number"/>
                              </div>
                            </template>

                            <template v-slot:cell(amount_total)="data">
                              <div v-if="data.item.currency">
                                <div class="text-danger" v-if="data.item.type_voucher.type_balance == '-'">
                                  <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount_total)}})</b>
                                </div>
                                <div class="text-success" v-else>
                                  <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount_total)}}</b>
                                </div>
                              </div>
                            </template>

                            <template v-slot:cell(amount_pending)="data">
                              <div v-if="data.item.currency">
                                <div class="text-success" v-if="data.item.type_voucher.type_balance == '+' && data.item.amount_total!=data.item.amount_impute">
                                  <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(getPendingVoucherSale(data.item))}}</b>
                                </div>
                              </div>
                            </template>

                            <template v-slot:cell(observations)="data">
                              <div v-if="data.item.observations">
                                <span v-if="isMobileViewport">{{data.item.observations}}</span>
                                <span v-else v-b-tooltip.hover :title="data.item.observations"><AppIcon name="chat-square-text" /></span>
                              </div>
                            </template>

                            <template v-slot:cell(observations_internal)="data">
                              <div v-if="data.item.observations_internal">
                                <span v-if="isMobileViewport">{{data.item.observations_internal}}</span>
                                <span v-else v-b-tooltip.hover :title="data.item.observations_internal"><AppIcon name="chat-square-text" class="text-info" /></span>
                              </div>
                            </template>

                            <template v-slot:cell(shipping_id)="data">
                              <div v-if="data.item.shipping">
                                <span v-if="isMobileViewport">{{data.item.shipping.name}}</span>
                                <span v-else v-b-tooltip.hover :title="data.item.shipping.name"><AppIcon name="truck" /></span>
                              </div>
                            </template>

                            <template v-slot:cell(f_action)="data">
                              <b-dropdown right
                                          no-caret
                                          size="sm"
                                          variant="link"
                                          boundary="window"
                                          toggle-class="app-table-action-toggle"
                                          class="pull-right">
                                <template #button-content>
                                  <AppIcon name="more_vert" label="Acciones" />
                                </template>

                                <b-dropdown-item @click="openSub(data.item)">
                                  <AppIcon name="visibility" /> Visualizar
                                </b-dropdown-item>
                                <b-dropdown-item @click="sendPrinterSale(data.item)" v-if="!data.item.afip_error">
                                  <AppIcon name="print" /> Imprimir
                                </b-dropdown-item>
                                <b-dropdown-item @click="openObservations(data.item)">
                                  <AppIcon name="chat-square-text" /> Observaciones Internas
                                </b-dropdown-item>
                                <b-dropdown-item @click="openShipping(data.item)" v-if="showShipping">
                                  <AppIcon name="truck" /> Transportista
                                </b-dropdown-item>

                                <b-dropdown-header v-if="data.item.point_sale && !data.item.point_sale.nd && (!data.item.afip || !data.item.afip_qr)">ARCA</b-dropdown-header>
                                <b-dropdown-item @click="showCaeAFIP(data.item)" v-if="data.item.point_sale && !data.item.point_sale.nd && (!data.item.afip || !data.item.afip_qr)">
                                  <AppIcon name="ticket" /> Buscar CAE
                                </b-dropdown-item>

                                <b-dropdown-header v-if="access.elements.deleteSales">Acciones</b-dropdown-header>
                                <b-dropdown-item @click="remove(data.item)" v-if="access.elements.deleteSales">
                                  <AppIcon name="delete" class="text-danger" /> Eliminar
                                </b-dropdown-item>
                              </b-dropdown>
                            </template>
                        </b-table>
                        <EmptyState v-else icon="reports" title="No se encontraron comprobantes" description="Ajustá los filtros o el rango de fechas para ampliar la búsqueda, o generá un comprobante nuevo con el botón Agregar." />

                        <div class="app-table-footer">
                          <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
                          <export-excel
                              class="list-view-link"
                              :data="arr.export"
                              worksheet="Listado de Ventas"
                              name="list-sales.xls">
                              <AppIcon name="download" class="mr-1" /> Exportar
                          </export-excel>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab v-if="access.elements.metricsSales">
                <template #title>
                  <AppIcon name="graph-up" label="Métricas" font-scale="1.5" />
                </template>
                <b-card-text>
                  <b-row>
                    <b-col md="9" v-if="showTimeMetrics">
                      <b-row>
                        <b-col md="5">
                          <b-form-group label="Hora Desde">
                            <b-form-timepicker
                              size="sm"
                              now-button
                              reset-button
                              v-model="filters.time_start"
                              locale="es">
                            </b-form-timepicker>
                          </b-form-group>
                        </b-col>
                        <b-col md="5">
                          <b-form-group label="Hora Hasta">
                            <b-form-timepicker
                              size="sm"
                              now-button
                              reset-button
                              v-model="filters.time_end"
                              locale="es">
                            </b-form-timepicker>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col :md="showTimeMetrics ? 3 : 12">
                      <b-button @click="filterSalesMetrics()" size="sm" type="button" variant="outline-dark" class="float-right mb-3" v-b-tooltip.hover title="Actualizar Datos">
                        <AppIcon name="refresh" class="mr-1" /> Actualizar datos
                      </b-button>
                    </b-col>
                    <b-col md="12">
                      <Metrics types="sales" :filters="filters" :key="itemFilterForceUpdate" v-if="itemFilterForceUpdate>0"/>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <!-- DRAWER: detalle del comprobante seleccionado -->
      <b-sidebar
          id="sidebar-sale-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Comprobante"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.type_voucher && itemSelected.point_sale">
                {{itemSelected.type_voucher.name}} {{itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + itemSelected.number.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.customer">{{itemSelected.customer.name}}</div>
              <div class="list-view-drawer__meta" v-if="itemSelected.date">
                {{moment(itemSelected.date).format('DD/MM/YYYY')}}
              </div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrevSale"
                        v-b-tooltip.hover
                        title="Comprobante anterior"
                        @click="goPrevSale()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNextSale"
                        v-b-tooltip.hover
                        title="Comprobante siguiente"
                        @click="goNextSale()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats" v-if="itemSelected.currency">
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Total</span>
              <span class="list-view-drawer__stat-value">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(itemSelected.amount_total)}}
              </span>
            </div>
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': (itemSelected.amount_total != itemSelected.amount_impute) && itemSelected.type_voucher.type_balance=='+' }" v-if="itemSelected.type_voucher.type_balance=='+'">
              <span class="list-view-drawer__stat-label">Pendiente</span>
              <span class="list-view-drawer__stat-value">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(getPendingVoucherSale(itemSelected))}}
              </span>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="list-ul" /> Detalle
            </div>

            <b-table  class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSub.items"
                      :fields="tableSub.fields"
                      v-if="tableSub.items.length">

              <template v-slot:cell(quantity)="row">
                {{row.item.quantity}}
                <span v-if="row.item.unit_measurement">{{row.item.unit_measurement.reference}}</span>
              </template>

              <template v-slot:cell(code)="row">
                <div v-html="getDetailCode(row.item)"></div>
              </template>

              <template v-slot:cell(product)="row">
                <div class="text-truncate" v-b-tooltip.hover :title="getDetailName(row.item)" v-html="getDetailName(row.item)"></div>
              </template>

            </b-table>
            <EmptyState v-else icon="list-ul" title="Sin items cargados" />
          </div>

          <div v-if="tableSubImputation.items.length">
            <div class="list-view-drawer__section-title">
              <AppIcon name="paperclip" /> Imputaciones
            </div>

            <b-table  class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSubImputation.items"
                      :fields="tableSubImputation.fields">

              <template v-slot:cell(date)="row">
                {{moment(row.item.date).format('DD/MM/YYYY')}}
              </template>

              <template v-slot:cell(amount_total)="row">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency: itemSelected.currency.code}).format(row.item.amount_total)}}
              </template>

            </b-table>
          </div>

          <b-button v-if="tableSub.items.length"
                    block
                    size="sm"
                    variant="outline-secondary"
                    class="text-left"
                    @click="openDetail()">
            <AppIcon name="visibility" class="mr-1" /> Ver detalle completo
          </b-button>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="sendPrinterSale(itemSelected)" v-if="!itemSelected.afip_error">
              <AppIcon name="print" class="mr-1" /> Imprimir
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="openObservations(itemSelected)">
              <AppIcon name="chat-square-text" class="mr-1" /> Observaciones Internas
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showShipping" @click="openShipping(itemSelected)">
              <AppIcon name="truck" class="mr-1" /> Transportista
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.point_sale && !itemSelected.point_sale.nd && (!itemSelected.afip || !itemSelected.afip_qr)" @click="showCaeAFIP(itemSelected)">
              <AppIcon name="ticket" class="mr-1" /> Buscar CAE
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && access.elements.deleteSales">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate">
                <b-pagination class="mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterSales()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id && crud.print.mode == 'pdf'"
              :reference="crud.print.reference"
              :registerID="crud.print.id"
              :key="'pdf-' + crud.print.key"
              :manyFormat="true"/>

      <EscposPrinter v-if="crud.print.id && crud.print.mode == 'thermal_printer'"
                     :reference="crud.print.reference"
                     :registerID="crud.print.id"
                     :key="'thermal-printer-' + crud.print.key"
                     :manyFormat="true"
                     :direct="true"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              dialog-class="sales-form-modal-dialog"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-alert show variant="info" v-if="crud.form.budget && crud.form.budget_ids" class="crud_sales_alert_from">
          <b>Desde {{crud.form.budgets_list.length}} PRESUPUESTOS: {{crud.form.budgets_list.map(b => b.point_sale.point_sale.toString().padStart(4,'0') + '-' + b.number.toString().padStart(8,'0')).join(', ')}}</b>
        </b-alert>
        <b-alert show variant="info" v-if="crud.form.budget && !crud.form.budget_ids" class="crud_sales_alert_from">
          <b>Desde {{crud.form.budget.type_voucher.name + ' ' + crud.form.budget.point_sale.point_sale.toString().padStart(4,'0') + '-' + crud.form.budget.number.toString().padStart(8,'0')}}</b>
        </b-alert>
        <b-alert show variant="info" v-if="crud.form.remits" class="crud_sales_alert_from">
          <b>Desde {{crud.form.remits.type_voucher.name + ' ' + crud.form.remits.point_sale.point_sale.toString().padStart(4,'0') + '-' + crud.form.remits.number.toString().padStart(8,'0')}}</b>
        </b-alert>
        <b-alert show variant="info" v-if="crud.form.orders" class="crud_sales_alert_from">
          <b>Desde Orden de Pedido {{crud.form.orders.points_sales.point_sale.toString().padStart(4,'0') + '-' + crud.form.orders.id.toString().padStart(8,'0')}}</b>
        </b-alert>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="preSave"
                      class="crud-sales-wizard"
                      ref="wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="saleValidCrudGeneral">
            <b-row>
              <b-col md="4">
                <FindObject render="search"
                            type="customers"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customers_id"
                            :where="conditionCustomersActive"
                            :key="crud.form.customers_id"
                            :disabled="crud.form.id>0 || invoiceFrom"
                            ref="searchCustomer"
                            title="Buscador (F2)" />
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es" :disabled="disabledDates"></b-form-datepicker>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha Vencimiento">
                  <b-form-datepicker size="sm" v-model="crud.form.date_expiration" placeholder="Fecha Vencimiento" local="es" :disabled="disabledDates"></b-form-datepicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FindObject render="search"
                            type="erpPointsSales"
                            auto-select-single
                            display="full_identification"
                            @select-object="loadPointsSales($event)"
                            :valueID="crud.form.points_sales_id"
                            :key="crud.form.points_sales_id"
                            :disabled="crud.form.id>0 || invoiceFrom"
                            :where="conditionPointsSalesActive" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="erpMethodsPayment"
                            auto-select-single
                            @select-object="loadMethodsPayment($event)"
                            :valueID="crud.form.methods_payment_id"
                            :key="crud.form.methods_payment_id"
                            :disabled="crud.form.id>0 || invoiceFrom" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="priceList"
                            @select-object="loadPriceList($event)"
                            :valueID="crud.form.price_list_id"
                            :key="crud.form.price_list_id"
                            :where="conditionPriceListActive"
                            :disabled="crud.form.id>0 || invoiceFrom" />
              </b-col>
            </b-row>
            <b-row v-if="(parameters.haveAcopio && crud.form.selectTypeVoucher!='notacredito') || showShipping">
              <b-col md="4" v-if="parameters.haveAcopio && crud.form.selectTypeVoucher!='notacredito'">
                <FindObject render="search"
                            type="erpMethodsAcopio"
                            @select-object="loadMethodsAcopio($event)"
                            :valueID="crud.form.methods_acopio_id"
                            :key="crud.form.methods_acopio_id"
                            :disabled="crud.form.id>0 || invoiceFrom" />
              </b-col>

              <b-col md="4" v-if="showShipping">
                <FindObject render="search"
                            type="suppliers"
                            @select-object="loadShipping($event)"
                            :where="conditionSuppliersShippingActive"
                            :valueID="crud.form.shipping_id"
                            tag="Transporte"
                            :key="crud.form.shipping_id"
                            :showAllRegister="true"/>
              </b-col>
            </b-row>

            <b-row v-if="balanceCurrentAccount<0">
              <b-col>
                <b-alert show variant="danger">
                  <AppIcon name="exclamation-triangle" class="mr-1" />Se encontró saldo a favor del cliente: <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(balanceCurrentAccount)}})</b>
                </b-alert>
              </b-col>
            </b-row>

            <b-row v-if="crud.form.points_sales && !crud.form.points_sales.nd">
              <b-col>
                <div v-if="crud.form.points_sales.status">
                  <b-alert show variant="info" v-if="crud.form.points_sales.afip_production">
                    Punto de venta conectado a los servidores de ARCA <b>"EN PRODUCCIÓN"</b>
                  </b-alert>
                  <b-alert show variant="warning" v-else>
                    Punto de venta conectado a los servidores de ARCA <b>"HOMOLOGACION"</b>
                  </b-alert>
                </div>
                <div v-else>
                  <b-alert show variant="danger">
                    El punto de venta está <b>INACTIVO</b>
                  </b-alert>
                </div>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Detalle" icon="fa fa-list" :before-change="saleValidCrudDetail">
            <b-row>
              <b-col lg="12" md="12" sm="12">
                  <Detail :customer_id="crud.form.customers_id"
                          :price_list_id="crud.form.price_list_id"
                          :disable-customer-price-list-fallback="crud.form.disable_customer_price_list_fallback"
                          @load-detail-products="setDetailItems($event, 'products')"
                          @load-detail-products-compound="setDetailItems($event, 'productsCompound')"
                          @load-detail-services="setDetailItems($event, 'services')"
                          @load-detail-concepts="setDetailItems($event, 'concepts')"
                          :detailProducts="crud.form.detailProducts"
                          :detailProductsCompound="crud.form.detailProductsCompound"
                          :detailServices="crud.form.detailServices"
                          :detailConcepts="crud.form.detailConcepts"
                          :forceUpdate="itemForceUpdateDetail"
                          :hideConcepts="false"
                          :validItemDuplicatedProduct="!parameters.multipleItems"
                          :validItemDuplicatedConcept="!parameters.multipleItems"
                          :onlyDiscountProduct="invoiceFrom"
                          :editPrice="!notEditPrice"
                          :methodPayment="crud.form.methods_payment"/>


                  <b-row class="mt-0 pt-1 pl-3 pr-3" align-v="end">
                    <b-col md="6" class="mb-0" v-if="showRemits">
                      <b-form-checkbox
                        v-if="crud.form.types_vouchers && crud.form.types_vouchers.type_balance == '+'"
                        v-model="crud.form.generateRemits"
                        switch
                        size="sm"
                        class="pull-left">
                        <b>Generar Remito</b> <i>(Descuenta Stock)</i>
                      </b-form-checkbox>
                    </b-col>
                    <b-col md="6" :offset-md="showRemits ? 0 : 6" class="mb-0" v-if="showCheckNotIva">
                      <b-form-checkbox
                        v-model="crud.form.not_iva"
                        switch
                        size="sm"
                        class="pull-right">
                        <b>Precios sin IVA</b>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                  <b-row class="pl-3 pr-3 pb-2 mt-2">
                    <b-col md="2" class="mb-2 mb-md-0">
                      <div class="crud-sales-stat">
                        <span class="crud-sales-stat__label">Items</span>
                        <span class="crud-sales-stat__value">{{this.getCantItemSale}}</span>
                      </div>
                    </b-col>
                    <b-col md="6" class="mb-2 mb-md-0">
                      <div class="text-center"
                           v-if="crud.form.customers && crud.form.customers.data_fiscal && crud.form.customers.data_fiscal.fiscal_conditions_id == 5">

                        <b-link href="javascript:void(0);"
                                @click="showCustomerIdentification = true"
                                v-if="!showCustomerIdentification">
                          <AppIcon name="person" class="mr-1" />Modificar datos del consumidor final
                        </b-link>

                        <b-card
                            id="container_consumer_indentification"
                            class="mb-0"
                            no-body
                            v-if="showCustomerIdentification">
                          <div slot="header" class="app-modal-header py-2">
                            <span class="app-modal-header__icon"><AppIcon name="person" /></span>
                            <h5 class="app-modal-header__title" style="font-size:14px;">Datos Consumidor Final</h5>
                          </div>

                          <b-row class="pl-3 pr-3 pt-1 pb-2">
                            <b-col md="6">
                              <b-form-group label="Nombre y Apellido" class="mb-0">
                                <b-form-input type="text"
                                              size="sm"
                                              v-model="crud.form.customer_name"
                                              required
                                              placeholder="Nombre y Apellido">
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="DNI" class="mb-0">
                                <b-form-input type="text"
                                              size="sm"
                                              v-model="crud.form.customer_document_number"
                                              required
                                              placeholder="DNI">
                                </b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="12" class="mt-1">
                              <b-button variant="outline-dark"
                                        size="sm"
                                        class="w-100"
                                        @click="showCustomerIdentification = false">
                                Listo
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-card>

                      </div>
                    </b-col>
                    <b-col md="4" v-if="getCurrencySale">
                      <div class="crud-sales-totals">
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">Subtotal</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.subtotal)}}</span>
                        </div>
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">Descuento</span>
                          <div class="crud-sales-totals__discount-group">
                            <div class="crud-sales-totals__discount">
                              <b-form-input v-model="crud.form.percentage_discount"
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="1"
                                    size="sm"
                                    @change="validDiscounts()"/>
                              <span class="crud-sales-totals__discount-suffix">%</span>
                            </div>
                            <span class="crud-sales-totals__value" :class="{'text-danger': parseFloat(totals.discount) > 0}">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.discount)}}</span>
                          </div>
                        </div>
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">Subtotal</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.subtotal_discount)}}</span>
                        </div>
                        <div class="crud-sales-totals__row">
                          <span class="crud-sales-totals__label">IVA</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.iva)}}</span>
                        </div>
                        <div class="crud-sales-totals__row crud-sales-totals__row--total">
                          <span class="crud-sales-totals__label">Total</span>
                          <span class="crud-sales-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.total)}}</span>
                        </div>
                        <div class="crud-sales-totals__row crud-sales-totals__row--total" v-if="crud.form.methods_payment && parseFloat(crud.form.methods_payment.surcharge) > 0">
                          <span class="crud-sales-totals__label">{{this.crud.form.methods_payment.name}} ({{ this.crud.form.methods_payment.surcharge }}%)</span>
                          <span class="crud-sales-totals__value text-primary">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(totals.total_surcharge)}}</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="pl-3 pr-3 pb-1" v-if="showMethodPaymentOptions">
                    <b-col md="12" class="text-right pr-0">
                      <b-button variant="outline-info"
                                size="sm"
                                @click="showSurchargeMethodPayment()">
                        <AppIcon name="money" class="mr-1" />
                        Otros Métodos de Pago
                      </b-button>
                    </b-col>
                  </b-row>

              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Facturas" icon="fa fa-link" :before-change="saleValidCrudRelation" v-if="crud.form.selectTypeVoucher=='notacredito' || crud.form.selectTypeVoucher=='notadebito'">
            <b-row>
              <b-col v-if="true">
                <VoucherRelation  :customer_id="crud.form.customers_id"
                                  :point_sale_id="crud.form.points_sales_id"
                                  :details="crud.form.invoiceRelated"
                                  :amount="totals.total_surcharge"
                                  :currency="(crud.form.price_list && crud.form.price_list.currency) ? crud.form.price_list.currency : {code:'ARS', symbol:'$', manual: true}"
                                  :singleVoucher="(crud.form.detailProducts.length>0 || crud.form.detailProductsCompound.length>0)"
                                  :typeVoucher="crud.form.selectTypeVoucher"
                                  :key="'invoice_related_' + itemForceUpdate"
                                  @getInvoice="getInvoiceRelated($event)" />
              </b-col>
              <b-col v-else>
                <b-alert variant="warning" show>
                  <h4 class="alert-heading">No se encontró la moneda</h4>
                  <p>
                    Debe seleccionar una lista de precios para poder buscar una factura relacionada
                  </p>
                </b-alert>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Asiento Contable" icon="fa fa-balance-scale" :before-change="salesValidCrudAccounting" v-if="showContabilidad">
            <div v-if="contabilidad.render" :key="'accounting_' + itemAccountingForceUpdate">
              <AccountingEntries  :typeDebe="contabilidad.typeDebe"
                                  :typeHaber="contabilidad.typeHaber"
                                  :defaultDebe="contabilidad.defaultDebe"
                                  :defaultHaber="contabilidad.defaultHaber"
                                  :reference="contabilidad.reference"
                                  :amountTotal="contabilidad.amountTotal"
                                  @getAsiento="getAsiento($event)" />
            </div>
          </tab-content>

          <tab-content title="Observaciones" icon="fa fa-flag-checkered">
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                    lazy
                  ></app-textarea>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Observaciones Internas" description="Estas observaciones no se muestran en la impresión">
                  <app-textarea
                    v-model="crud.form.observations_internal"
                    placeholder="Ingresar las observaciones internas..."
                    rows="3"
                    max-rows="6"
                    lazy
                  ></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>

        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD DISCOUNTS (NOTA DE CREDITO) -->
      <b-modal v-model="modal.discounts.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              :key="modal.discounts._id"
              :id="modal.discounts._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="percent" /></span>
          <h5 class="app-modal-header__title">{{this.modal.discounts.title}}</h5>
        </div>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save"
                      class="crud-sales-wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="saleValidCrudGeneralDiscounts">
            <b-row>
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
             <b-col md="4">
                <FindObject render="search"
                            type="customers"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customers_id"
                            :where="conditionCustomersActive"
                            :key="crud.form.customers_id"
                            :disabled="crud.form.id>0 || invoiceFrom" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="erpPointsSales"
                            auto-select-single
                            display="full_identification"
                            @select-object="loadPointsSales($event)"
                            :valueID="crud.form.points_sales_id"
                            :key="crud.form.points_sales_id"
                            :disabled="crud.form.id>0 || invoiceFrom"
                            :where="conditionPointsSalesActive" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="erpMethodsPayment"
                            auto-select-single
                            @select-object="loadMethodsPayment($event)"
                            :valueID="crud.form.methods_payment_id"
                            :key="crud.form.methods_payment_id"
                            :disabled="crud.form.id>0 || invoiceFrom" />
              </b-col>
              <b-col md="12">
                <FindObject render="search"
                            type="concepts"
                            @select-object="loadConcepts($event)"
                            :valueID="crud.form.concepts_id"
                            :key="crud.form.points_sales_id"
                            :disabled="crud.form.id>0 || invoiceFrom" />
              </b-col>
            </b-row>
            <b-row v-if="balanceCurrentAccount<0 && crud.form.selectTypeVoucher=='notacredito'">
              <b-col>
                <b-alert show variant="danger">
                  <AppIcon name="exclamation-triangle" class="mr-1" />Se encontró saldo a favor del cliente: <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(balanceCurrentAccount)}})</b>
                </b-alert>
              </b-col>
            </b-row>

            <b-row v-if="crud.form.points_sales && !crud.form.points_sales.nd">
              <b-col>
                <div v-if="crud.form.points_sales.status">
                  <b-alert show variant="info" v-if="crud.form.points_sales.afip_production">
                    Punto de venta conectado a los servidores de ARCA <b>"EN PRODUCCIÓN"</b>
                  </b-alert>
                  <b-alert show variant="warning" v-else>
                    Punto de venta conectado a los servidores de ARCA <b>"HOMOLOGACION"</b>
                  </b-alert>
                </div>
                <div v-else>
                  <b-alert show variant="danger">
                    El punto de venta está <b>INACTIVO</b>
                  </b-alert>
                </div>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Imputación" icon="fa fa-paperclip" :before-change="saleValidCrudImputationDiscounts">
            <b-row>
              <b-col lg="12" md="12" sm="12">
                <b-table-simple hover small caption-top responsive v-if="arr.pending.length" class="app-table app-table--compact app-table--stacked-manual crud-sales-table-items">
                  <b-thead>
                    <b-tr>
                      <b-th width="7%" class="text-left">Aplicar</b-th>
                      <b-th width="10%" class="text-left">Fecha</b-th>
                      <b-th width="33%" class="text-left">Comprobante</b-th>
                      <b-th width="10%" class="text-right">Total</b-th>
                      <b-th width="10%" class="text-right">Pendiente</b-th>
                      <b-th width="10%" class="text-center">Desc (%)</b-th>
                      <b-th width="10%" class="text-right">Desc ($)</b-th>
                      <b-th width="10%" class="text-right">Desc + Imp</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-for="(item, index) in arr.pending" :key="item.id">
                    <b-tr :key="itemForceUpdate" v-if="crud.formPending[index]">
                      <b-td data-label="Aplicar" :class="'align-middle ' + alignClass('text-left')">
                        <b-form-checkbox v-model="crud.formPending[index].check"
                                          @change="validCheck(index)"
                                          switch
                                          size="sm"
                                          class="pull-left">
                        </b-form-checkbox>
                      </b-td>
                      <b-td data-label="Fecha" :class="'align-middle ' + alignClass('text-left')">
                        {{moment(item.date).format('DD/MM/YYYY')}}
                      </b-td>
                      <b-td data-label="Comprobante" :class="'align-middle ' + alignClass('text-left')">
                        {{item.type_voucher.name + ' ' + item.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')}}
                      </b-td>
                      <b-td data-label="Total" :class="'align-middle ' + alignClass('text-right')">
                        <div class="text-danger" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                        </div>
                        <div class="text-success" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                        </div>
                      </b-td>
                      <b-td data-label="Pendiente" :class="'align-middle ' + alignClass('text-right')">
                        <div class="text-danger" v-if="item.type_voucher.type_balance == '-'">
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                        </div>
                        <div class="text-success" v-else>
                          <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                        </div>
                      </b-td>
                      <b-td data-label="Desc (%)" :class="'align-middle ' + alignClass('text-center')">
                        <app-number-input size="sm"
                                      @change="validAmount(index)"
                                      v-model="crud.formPending[index].discounts"
                                      placeholder="Ingresar monto a imputar"
                                      class="crud-sales-item-input"
                                      v-if="crud.formPending[index].check" />
                      </b-td>
                      <b-td data-label="Desc ($)" :class="'align-middle ' + alignClass('text-right')">
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(crud.formPending[index].amount)}}</b>
                      </b-td>
                      <b-td data-label="Desc + Imp" :class="'align-middle ' + alignClass('text-right')">
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(crud.formPending[index].amount_total)}}</b>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
                <EmptyState v-else icon="paperclip" title="No hay comprobante para imputar" />
              </b-col>
            </b-row>
            <b-row align-h="end" class="mb-2">
              <b-col lg="4" md="4" sm="4">
                <b-input-group size="sm" prepend="DESCUENTO">
                  <b-form-input :value="calc.discounts"
                                type="text"
                                :readonly="true"
                                class="crud-sales-add-total-final">
                  </b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Asiento Contable" icon="fa fa-balance-scale" :before-change="salesValidCrudAccounting" v-if="showContabilidad">
            <div v-if="contabilidad.render" :key="'accounting_' + itemAccountingForceUpdate">
              <AccountingEntries  :typeDebe="contabilidad.typeDebe"
                                  :typeHaber="contabilidad.typeHaber"
                                  :defaultDebe="contabilidad.defaultDebe"
                                  :defaultHaber="contabilidad.defaultHaber"
                                  :reference="contabilidad.reference"
                                  :amountTotal="contabilidad.amountTotal"
                                  @getAsiento="getAsiento($event)" />
            </div>
          </tab-content>

          <tab-content title="Observaciones" icon="fa fa-flag-checkered">
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                  ></app-textarea>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Observaciones Internas" description="Estas observaciones no se muestran en la impresión">
                  <app-textarea
                    v-model="crud.form.observations_internal"
                    placeholder="Ingresar las observaciones internas..."
                    rows="3"
                    max-rows="6"
                    lazy
                  ></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>

        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              size="xl"
              dialog-class="sales-form-modal-dialog"
              :key="modal.detail._id"
              :id="modal.detail._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">{{this.modal.detail.title}}</h5>
        </div>

        <b-row>
          <b-col sm="12">
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab>
                <template #title><AppIcon name="description" class="mr-1" /> General</template>
                <div class="app-modal-detail-list" v-if="itemSelected">
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">ID</span>
                    <span class="app-modal-detail-list__value"><b>#{{this.itemSelected.id}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Empresa</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.point_sale.business.reference}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.type_voucher && itemSelected.point_sale">
                    <span class="app-modal-detail-list__label">Comprobante</span>
                    <span class="app-modal-detail-list__value"><b>{{this.itemSelected.type_voucher.name + ' ' + this.itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.number.toString().padStart(8,'0')}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.remit && itemSelected.remit.type_voucher && itemSelected.remit.point_sale">
                    <span class="app-modal-detail-list__label">Remito</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.remit.type_voucher.name + ' ' + this.itemSelected.remit.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.remit.number.toString().padStart(8,'0')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.order && itemSelected.order.points_sales">
                    <span class="app-modal-detail-list__label">Pedido</span>
                    <span class="app-modal-detail-list__value">PEDIDO {{this.itemSelected.order.points_sales.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.order.id.toString().padStart(8,'0')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="(itemSelected.budget && itemSelected.budget.point_sale && itemSelected.budget.type_voucher) || (itemSelected.budget_stage_related && itemSelected.budget_stage_related.budget && itemSelected.budget_stage_related.budget.point_sale && itemSelected.budget_stage_related.budget.type_voucher)">
                    <span class="app-modal-detail-list__label">Presupuesto</span>
                    <span class="app-modal-detail-list__value">
                      <span v-if="itemSelected.budget">{{this.itemSelected.budget.type_voucher.name + ' ' + this.itemSelected.budget.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.budget.number.toString().padStart(8,'0')}}</span>
                      <span v-else>{{this.itemSelected.budget_stage_related.budget.type_voucher.name + ' ' + this.itemSelected.budget_stage_related.budget.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.budget_stage_related.budget.number.toString().padStart(8,'0')}}</span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.staff || itemSelected.seller">
                    <span class="app-modal-detail-list__label">Emisor</span>
                    <span class="app-modal-detail-list__value">
                      <span v-if="itemSelected.seller">{{itemSelected.seller.name}}</span>
                      <span v-else>{{itemSelected.staff.name}}</span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha Vencimiento</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date_expiration).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.point_sale">
                    <span class="app-modal-detail-list__label">Punto de Venta</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.point_sale.point_sale}} - {{this.itemSelected.point_sale.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.customer">
                    <span class="app-modal-detail-list__label">Cliente</span>
                    <span class="app-modal-detail-list__value">
                      {{this.itemSelected.customer.name}}
                      <span v-if="itemSelected.afip_customer_identification">
                       <AppIcon name="forward" class="mr-1" />NOMBRE: {{itemSelected.afip_customer_identification.name}} - DNI: {{itemSelected.afip_customer_identification.document_number}}
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.method_payment">
                    <span class="app-modal-detail-list__label">Método de Pago</span>
                    <span class="app-modal-detail-list__value">
                      {{this.itemSelected.method_payment.name}}
                      <span v-if="parseFloat(itemSelected.method_payment.surcharge)>0">
                        ({{ parseFloat(itemSelected.method_payment.surcharge) }}%)
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.method_acopio && parameters.haveAcopio">
                    <span class="app-modal-detail-list__label">Método de Acopio</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.method_acopio.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.shipping">
                    <span class="app-modal-detail-list__label">Transporte</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.shipping.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency && itemSelected.amount_discount > 0">
                    <span class="app-modal-detail-list__label">Neto</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(parseFloat(this.itemSelected.amount_net) + parseFloat(this.itemSelected.amount_discount))}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency && itemSelected.amount_discount > 0">
                    <span class="app-modal-detail-list__label">Descuento ({{itemSelected.percentage_discount}} %)</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning">({{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_discount)}})</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">SubTotal</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_net)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">IVA</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_iva)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">Total</span>
                    <span class="app-modal-detail-list__value">
                      <span class="text-danger" v-if="itemSelected.type_voucher.type_balance == '-'">
                        <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_total)}})</b>
                      </span>
                      <b v-else>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_total)}}</b>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="(itemSelected.amount_impute!=itemSelected.amount_total) && itemSelected.type_voucher.type_balance=='+'">
                    <span class="app-modal-detail-list__label">Pendiente de Imputación</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning"><b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(getPendingVoucherSale(this.itemSelected))}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations">
                    <span class="app-modal-detail-list__label">Observaciones</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.observations}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations_internal">
                    <span class="app-modal-detail-list__label">Observaciones Internas</span>
                    <span class="app-modal-detail-list__value"><div v-html="itemSelected.observations_internal"></div></span>
                  </div>
                </div>
              </b-tab>

              <b-tab>
                <template #title><AppIcon name="list-ul" class="mr-1" /> Items</template>
                <b-row>
                  <b-col class="mb-2" lg="12" v-if="itemSelected && itemSelected.type_voucher && itemSelected.type_voucher.type_balance=='+'">
                    <b-form-checkbox v-model="crud.formDevolutionLote.enable"
                                      switch
                                      size="sm"
                                      class="pull-right">
                      Devolución múltiple items
                    </b-form-checkbox>
                  </b-col>
                  <b-col lg="12">
                    <b-table class="mb-0 app-table app-table--compact"
                            responsive
                            :stacked="isMobileViewport ? 'md' : false"
                            :hover="true"
                            :small="true"
                            :fixed="true"
                            :items="tableDetail.items"
                            :fields="tableDetail.fields"
                            v-if="tableDetail.items.length">

                      <template v-slot:table-colgroup="scope">
                        <col
                          v-for="field in scope.fields"
                          :key="field.key"
                          :style="{ width: field.width }"
                        >
                      </template>

                      <template v-slot:cell(product)="data">
                        <div class="crud-sales-item-cell">
                          <div class="crud-sales-item-cell__code" v-html="getDetailCode(data.item)"></div>
                          <div class="crud-sales-item-cell__name" v-html="getDetailName(data.item)"></div>
                          <div v-if="getCreditNoteImpact(data.item)" class="sales-detail-credit-note-impact">
                            <AppIcon name="info" />
                            <span>
                              Afectado por NC: <b>{{getCreditNoteImpact(data.item).quantity}} {{data.item.unit_measurement ? data.item.unit_measurement.reference : ''}}</b>
                              <small>{{getCreditNoteImpact(data.item).references.join(' · ')}}</small>
                            </span>
                          </div>
                        </div>
                      </template>

                      <template v-slot:cell(list)="data">
                        <span v-if="data.item.price_list">
                          {{data.item.price_list.reference}}
                        </span>
                        <span v-else>
                          <span v-if="itemSelected.price_list">
                            {{itemSelected.price_list.reference}}
                          </span>
                        </span>
                      </template>

                      <template v-slot:cell(quantity)="data">
                        {{data.item.quantity}}
                        <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                      </template>

                      <template v-slot:cell(unit_price)="data">
                        <div v-if="itemSelected.currency">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.price_surcharge)}}
                        </div>
                      </template>

                      <template v-slot:cell(amount_net)="data">
                        <div v-if="itemSelected.currency">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_net)}}
                        </div>
                      </template>

                      <template v-slot:cell(subtotal)="data">
                        <div v-if="itemSelected.currency">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(parseFloat(data.item.quantity) * parseFloat(data.item.price_surcharge))}}
                        </div>
                      </template>

                      <template v-slot:cell(amount_iva)="data">
                        <div v-if="itemSelected.currency">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_iva)}}
                        </div>
                      </template>

                      <template v-slot:cell(amount_discount)="data">
                        <div v-if="itemSelected.currency" :class="{'text-danger':parseFloat(data.item.percentage_discount)>0}">
                          {{parseFloat(data.item.percentage_discount).toFixed(0)}}%
                          ({{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_discount)}})
                        </div>
                      </template>

                      <template v-slot:cell(amount_total)="data">
                        <div v-if="itemSelected.currency">
                          {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_total)}}
                        </div>
                      </template>

                      <template v-slot:cell(f_action)="data">
                        <div v-if="showCheckDevolution(data.item)">
                          <div v-if="itemSelected.type_voucher.type_balance=='+' && showDevolution(itemSelected)">
                            <div v-if="crud.formDevolutionLote.enable">
                              <b-form-checkbox v-model="crud.formDevolutionLote.data[data.index]['check']"
                                                @change="showDevolutionLote"
                                                size="sm"
                                                title="Agregar o Quitar - Nota de Crédito múltiple"
                                                class="pull-right">
                              </b-form-checkbox>
                            </div>
                            <div v-else>
                              <b-button size="sm" variant="link" class="app-table-icon-btn sales-detail-devolution-btn" v-b-tooltip.hover.left title="Devolución" @click="openDevolution(data.item)">
                                <AppIcon name="link_off" label="Devolución" font-scale="1.7" />
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-table>
                    <EmptyState v-else icon="reports" title="No se encontraron registros" />
                  </b-col>
                  <b-col class="mt-2" lg="12" v-if="itemSelected && itemSelected.type_voucher && crud.formDevolutionLote.enable && crud.formDevolutionLote.showButton">
                    <div v-if="!modal.devolution.wait">
                      <b-button variant="info" size="sm" class="pull-right" @click="creditNoteFromSalesDetail(itemSelected.id)"><AppIcon name="link_off" class="mr-1" />Generar NC múltiple</b-button>
                    </div>
                    <div v-else>
                      <b-button variant="info" size="sm" class="pull-right" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        Cargando...
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>

              <b-tab v-if="tableImputation.items.length">
                <template #title><AppIcon name="paperclip" class="mr-1" /> Imputaciones</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableImputation.items"
                        :fields="tableImputation.fields">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(date)="data">
                    {{moment(data.item.date).format('DD/MM/YYYY')}}
                  </template>

                  <template v-slot:cell(reference)="data">
                    <div class="text-truncate" v-b-tooltip.hover :title="data.item.reference">{{data.item.reference}}</div>
                  </template>

                  <template v-slot:cell(amount_total)="data">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency: itemSelected.currency.code}).format(data.item.amount_total)}}
                  </template>

                </b-table>
              </b-tab>

              <b-tab v-if="showContabilidad">
                <template #title><AppIcon name="bar-chart" class="mr-1" /> Asiento</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableAccounting.items"
                        :fields="tableAccounting.fields"
                        v-if="tableAccounting.items.length">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(code)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_code}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_code}}</span>
                    </div>
                  </template>

                  <template v-slot:cell(name)="data">
                    <div v-if="data.item.type=='Debe'">
                      <span>{{data.item.accounting_accounts_name}}</span>
                    </div>
                    <div v-if="data.item.type=='Haber'">
                      <span class="ml-5">{{data.item.accounting_accounts_name}}</span>
                    </div>
                  </template>

                  <template v-slot:cell(debit)="data">
                    <span v-if="data.item.type == 'Debe'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </span>
                  </template>

                  <template v-slot:cell(credit)="data">
                    <span v-if="data.item.type == 'Haber'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrency}).format(data.item.total)}}
                    </span>
                  </template>
                </b-table>
                <EmptyState v-else icon="reports" title="No se encontraron registros" />
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

      <!-- CRUD DEVOLUTION -->
      <b-modal v-model="modal.devolution.active" size="md">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="link_off" /></span>
          <h5 class="app-modal-header__title">{{this.modal.devolution.title}}</h5>
        </div>

        <b-row>
          <b-col sm="12">
            <div class="app-modal-detail-list">
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">Código</span>
                <span class="app-modal-detail-list__value">{{this.crud.formDevolution.code}}</span>
              </div>
              <div class="app-modal-detail-list__row">
                <span class="app-modal-detail-list__label">Nombre</span>
                <span class="app-modal-detail-list__value">{{this.crud.formDevolution.name}}</span>
              </div>
              <div class="app-modal-detail-list__row" v-if="crud.formDevolution.unit_measurement && parseFloat(crud.formDevolution.quantity_pending)>0">
                <span class="app-modal-detail-list__label">A Entregar</span>
                <span class="app-modal-detail-list__value"><b>{{this.crud.formDevolution.quantity_pending}} {{this.crud.formDevolution.unit_measurement.reference}}</b></span>
              </div>
              <div class="app-modal-detail-list__row" v-if="crud.formDevolution.unit_measurement && parseFloat(crud.formDevolution.quantity_pending)<=0">
                <span class="app-modal-detail-list__label">Cantidad</span>
                <span class="app-modal-detail-list__value"><b>{{this.crud.formDevolution.quantity_total}} {{this.crud.formDevolution.unit_measurement.reference}}</b></span>
              </div>
            </div>
          </b-col>
          <b-col sm="12" class="mt-3">
            <b-form-group label="Cantidad a Devolver" class="sales-devolution-quantity" v-if="crud.formDevolution.unit_measurement">
              <b-input-group :append="crud.formDevolution.unit_measurement.reference" size="sm">
                <b-form-input type="number"
                              v-model="crud.formDevolution.quantity"
                              min="0"
                              step="0.01"
                              class="text-right"
                              placeholder="Cantidad">
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <div v-if="!modal.devolution.wait">
            <b-button variant="outline-secondary" class="mr-1" @click="modal.devolution.active=false">Cancelar</b-button>
            <b-button variant="dark" @click="creditNoteFromSalesDetail(crud.formDevolution.sale_id)"><AppIcon name="link_off" class="mr-1" />Devolver</b-button>
          </div>
          <div v-else>
            <b-button variant="dark" disabled>
              <b-spinner small type="grow"></b-spinner>
              Cargando...
            </b-button>
          </div>
        </div>
      </b-modal>

      <!-- CRUD CAE-->
      <b-modal v-model="modal.cae.active">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="ticket" /></span>
          <h5 class="app-modal-header__title">{{this.modal.cae.title}}</h5>
        </div>

        <b-row>
          <b-col sm="12">

            <div class="list-view-drawer__title mb-2" v-if="itemSelected">
              <span class="list-view-drawer__code" v-if="itemSelected.type_voucher && itemSelected.point_sale">
                {{itemSelected.type_voucher.name}} {{itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + itemSelected.number.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.customer">{{this.itemSelected.customer.name}}</div>
            </div>

            <b-card class="mb-0" no-body>
              <div slot="header" class="app-modal-header py-2">
                <span class="app-modal-header__icon"><AppIcon name="person" /></span>
                <h5 class="app-modal-header__title" style="font-size:14px;">Datos Consumidor Final</h5>
              </div>

              <b-row class="pl-3 pr-3 pt-1 pb-2">
                <b-col md="6">
                  <b-form-group label="Nombre y Apellido" class="mb-0">
                    <b-form-input type="text"
                                  size="sm"
                                  v-model="crud.formCAE.customer_name"
                                  required
                                  placeholder="Nombre y Apellido">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="DNI" class="mb-0">
                    <b-form-input type="text"
                                  size="sm"
                                  v-model="crud.formCAE.customer_document_number"
                                  required
                                  placeholder="DNI">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.cae.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="getCaeAFIP()"><AppIcon name="ticket" class="mr-1" />Obtener</b-button>
        </div>
      </b-modal>

      <!-- CRUD OBSERVATIONS -->
      <b-modal v-model="modal.observations.active"
              no-close-on-backdrop
              hide-header-close
              size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="chat-square-text" /></span>
          <h5 class="app-modal-header__title">{{this.modal.observations.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <div class="list-view-drawer__title mb-2" v-if="itemSelected">
              <span class="list-view-drawer__code" v-if="itemSelected.type_voucher && itemSelected.point_sale">
                {{itemSelected.type_voucher.name}} {{itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + itemSelected.number.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.customer">{{this.itemSelected.customer.name}}</div>
            </div>
          </b-col>

          <b-col lg="12">
            <hr>
          </b-col>

          <b-col lg="12">
            <b-form-group label="Observaciones Internas"
                          description="Estas observaciones no se muestran en la impresión">
              <app-textarea
                v-model="crud.observations.observations_internal"
                placeholder="Ingresar las observaciones internas..."
                rows="3"
                max-rows="6"
                lazy
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.observations.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveObservations()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD FINANCE -->
      <b-modal v-model="modal.payment.active"
              no-close-on-backdrop
              hide-header-close
              size="md">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="money" /></span>
          <h5 class="app-modal-header__title">{{this.modal.payment.title}}</h5>
        </div>

        <b-card>
          <b-row>
            <b-col md="12">
              <FinanceADD @getFinances="storeFinances($event)"
                          v-if="crud.form.customers_id && crud.form.points_sales_id"
                          :points_sales="crud.form.points_sales"
                          :amount_impute="totals.total_surcharge"
                          :reset="finances.resetControl"
                          :default="finances.default"
                          :key="finances.forceUpdate"/>
            </b-col>
            <b-col md="12" class="mt-4">
              <b-alert show variant="info" v-if="crud.form.payment && !parseFloat(crud.form.payment.total)">
                <AppIcon name="info" class="mr-1" />Si el <b>cliente paga</b> en el momento, cargue el <b>detalle de la cobranza.</b><br><br>
                <i>En caso de no carga la cobranza, el comprobante quedará en cuenta corriente <b>pendiente de imputación</b></i>
              </b-alert>
              <div v-else>
                <b-alert show variant="success" v-if="parseFloat(crud.form.payment.total) == parseFloat(totals.total_surcharge)">
                  Comprobante Saldado
                </b-alert>
                <div v-else>
                  <b-alert show variant="warning" v-if="parseFloat(crud.form.payment.total) > parseFloat(totals.total_surcharge)">
                    <AppIcon name="exclamation-triangle" class="mr-1" />El importe recibido es mayor al total de los comprobantes imputado.<br>
                    <b>Importe Imputado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.totals.total_surcharge)}}<br>
                    <b>Importe Recibido</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.crud.form.payment.total)}}<br><br>
                    <i>El saldo quedará en cuenta corriente pendiente de imputación a favor del cliente</i>
                  </b-alert>
                  <b-alert show variant="danger" v-if="parseFloat(crud.form.payment.total) < parseFloat(totals.total_surcharge)">
                    <AppIcon name="exclamation-triangle" class="mr-1" />El importe recibido es menor al total de los comprobantes imputado.<br>
                    <b>Importe Imputado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.totals.total_surcharge)}}<br>
                    <b>Importe Recibido</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencySale}).format(this.crud.form.payment.total)}}<br><br>
                    <i>El comprobante quedará en cuenta corriente pendiente de imputación</i>
                  </b-alert>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancelPayment()">Cancelar</b-button>
          <b-button variant="dark" @click="save()" title="Finalizar (CTRL + SHIFT + ENTER)"><AppIcon name="save" class="mr-1" />Finalizar</b-button>
        </div>
      </b-modal>

      <!-- METODOS DE PAGO -->
      <b-modal v-model="modal.method_payment.active"
              no-close-on-backdrop
              hide-header-close
              size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="money" /></span>
          <h5 class="app-modal-header__title">{{this.modal.method_payment.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <MethodPaymentSurcharge v-if="crud.form.price_list && crud.form.price_list.currency"
                                    :amount="totals.total"
                                    :currency="crud.form.price_list.currency.code"
                                    @setMethodPayment="setMethodPayment($event)"/>

            <MethodPaymentSurcharge v-else
                                    :amount="totals.total"
                                    currency="ARS"
                                    @setMethodPayment="setMethodPayment($event)"/>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.method_payment.active=false">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD SHIPPING -->
      <b-modal v-model="modal.shipping.active"
              no-close-on-backdrop
              hide-header-close
              size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="truck" /></span>
          <h5 class="app-modal-header__title">{{this.modal.shipping.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <div class="list-view-drawer__title mb-2" v-if="itemSelected">
              <span class="list-view-drawer__code" v-if="itemSelected.type_voucher && itemSelected.point_sale">
                {{itemSelected.type_voucher.name}} {{itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + itemSelected.number.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.customer">{{this.itemSelected.customer.name}}</div>
            </div>
          </b-col>

          <b-col lg="12">
            <hr>
          </b-col>

          <b-col md="12" v-if="showShipping">
            <FindObject render="search"
                        type="suppliers"
                        @select-object="loadShipping($event, 'edit')"
                        :where="conditionSuppliersShippingActive"
                        :valueID="crud.shipping.shipping_id"
                        tag="Transporte"
                        :key="crud.shipping.shipping_id"
                        :showAllRegister="true"/>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.shipping.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveShipping()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import Printer from '@/components/inc/printer/printer'
  import EscposPrinter from '@/components/inc/printer/escposPrinter'
  import Detail from '@/components/inc/cpbtDetail/detail'
  import moment from 'moment'
  import AccountingEntries from '@/components/inc/accounting/entries'
  import VoucherRelation from './inc/detailInvoice'
  import MethodPaymentSurcharge from './inc/methodPayment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Param from '@/config/parameters'
  import Function from '@/handler/funciones'
  import Metrics from '@/components/inc/metrics/metrics'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import FinanceADD from '@/components/inc/finances/add'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      Printer,
      EscposPrinter,
      Detail,
      FormWizard,
      TabContent,
      AccountingEntries,
      VoucherRelation,
      Metrics,
      MethodPaymentSurcharge,
      FinanceADD,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.VENTAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'sales',
          elements: {
            createCreditNoteDiscounts: true,
            deleteSales: true,
            metricsSales: true,
          }
        },
        parameters: {
          haveAcopio: Helper.hasParametersAccess(Param.P49),
          multipleItems: Helper.hasParametersAccess(Param.P50),
          freeAddTypeOperation: Helper.hasParametersAccess(Param.P61),
          haveNotIva: Helper.hasParametersAccess(Param.P65),
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        tableSub : {
          items: [],
          fields: []
        },
        tableDetail : {
          items: [],
          fields: []
        },
        creditNotesDetails: [],
        tableAccounting : {
          items: [],
          fields: []
        },
        tableImputation : {
          items: [],
          fields: []
        },
        // Tabla siempre-vertical dentro del drawer (b-sidebar de ancho fijo,
        // no depende de isMobileViewport): alineación fija a la izquierda,
        // separada de tableImputation (usada en el modal de detalle, cuyo
        // alineado sí depende del ancho real de la ventana).
        tableSubImputation : {
          items: [],
          fields: []
        },
        itemSelected: null,
        detailDrawer: false,
        filtersOpen: false,
        // Reactivo al viewport real (matchMedia), nunca un string fijo:
        // BootstrapVue apaga sticky-header si `stacked` está seteado a
        // cualquier valor truthy, incluso en desktop.
        isMobileViewport: false,
        crud: {
          form: {
            id: 0,
            date: '',
            date_expiration: '',
            types_vouchers_id: 0,
            types_vouchers: null,
            letter: '',
            number: 0,
            methods_payment_id: 0,
            methods_payment: null,
            price_list_id: 0,
            price_list: null,
            disable_customer_price_list_fallback: false,
            points_sales_id: 0,
            points_sales: null,
            observations: '',
            observations_internal: '',
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            percentage_discount: 0,
            detailProducts: [],
            detailProductsCompound: [],
            detailServices: [],
            detailConcepts: [],
            invoiceRelated: [],
            selectTypeVoucher: 'factura',
            selectDestination: 'default',
            accountingEntry: null,
            concepts: null,
            concepts_id: 0,
            remits: null,
            remits_id: 0,
            orders: null,
            orders_id: 0,
            payment: [],
            showPayment: true,
            generateRemits: false,
            disabled: false,
            methods_acopio_id: 0,
            methods_acopio: null,
            budget_id: 0,
            budget_ids: '',
            budget: null,
            budgets_list: [],
            isBudgetStage: false,
            budgetAmountImpute: 0,
            customer_name: '',
            customer_document_number: '',
            shipping_id: 0,
            shipping: null,
            isSaveConfirmActive: false,
            services_customer_id: 0,
            projects_id: 0,
            not_iva: false,
            _idempotency_key: crypto.randomUUID(),
          },
          formPending: [],
          formDevolution: {
            sale_id: 0,
            sale_detail_id: 0,
            sale_detail: null,
            code: '',
            name: '',
            quantity: 0,
            quantity_pending: 0,
            quantity_total: 0,
            unit_measurement: null,
          },
          formDevolutionLote: {
            enable: false,
            showButton: false,
            data : [],
          },
          formCAE: {
            id: 0,
            customer_name: '',
            customer_document_number: '',
          },
          print: {
            reference: '',
            id: 0,
            key: 0,
            mode: 'pdf',
          },
          observations: {
            id: 0,
            observations_internal: '',
          },
          shipping: {
            id: 0,
            shipping_id: 0,
            shipping: null,
          },
        },
        totals: {
          subtotal: 0,
          discount: 0,
          iva: 0,
          total: 0,
          total_surcharge: 0,
          arrIva: [],
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          detail: {
            active: false,
            title: '',
          },
          discounts: {
            active: false,
            title: '',
          },
          devolution: {
            active: false,
            title: '',
            wait: false,
          },
          cae: {
            active: false,
            title: '',
          },
          observations: {
            active: false,
            title: ''
          },
          payment: {
            active: false,
            title: '',
          },
          method_payment: {
            active: false,
            title: ''
          },
          shipping: {
            active: false,
            title: ''
          },
        },
        arr: {
          sales: [],
          pending: [],
          export: [],
          ivaCondition: [],
          financesCash: [],
          filters : {
            customers: [],
            sellers: [],
            points_sales: [],
            types_vouchers: [],
            status_imputation: [
              {code: true, label: 'Cancelado'},
              {code: false, label: 'Pendiente'}
            ],
            shipping: [],
          },
        },
        filters: {
          date_start: '',
          date_end: '',
          customers: null,
          sellers: null,
          points_sales: null,
          types_vouchers_id: null,
          status_imputation: null,
          number: '',
          shipping: null,
          time_start: null,
          time_end: null,
        },
        itemForceUpdate: 0,
        itemAccountingForceUpdate: 0,
        itemFilterForceUpdate: 0,
        itemForceUpdateDetail: 0,
        contabilidad: {
          render: false,
          typeDebe:"",
          typeHaber:"",
          defaultDebe:[],
          defaultHaber:[],
          reference:'',
          amountTotal:0
        },
        aux: {
          detailProducts: [],
          detailProductsCompound: [],
          detailServices: [],
          detailConcepts: [],
        },
        calc: {
          discounts: 0,
        },
        balanceCurrentAccount: 0,
        showCustomerIdentification: true,
        availableMethodPaymentCount: 0,
        configurations: null,
        isSaving: false,
        generationOrigin: null,
        finances: {
          default: null,
          staff: null,
          forceUpdate: 0,
          resetControl: false,
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.createCreditNoteDiscounts = Helper.hasAccessElement(this.access, 'create_credit_note_discounts')
      this.access.elements.deleteSales = Helper.hasAccessElement(this.access, 'delete_sales')
      this.access.elements.metricsSales = Helper.hasAccessElement(this.access, 'metrics_sales')
      /* Fin configuracion */

      window.addEventListener("keydown", this.handlerAccessDirect);
    },
    destroyed() {
      window.removeEventListener("keydown", this.handlerAccessDirect);
    },
    deactivated() {
      window.removeEventListener("keydown", this.handlerAccessDirect);
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_sales') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadConfigurations()
      this.getIvaCondition()
      this.loadAvailableMethodsPayment()

      this.checkGenerateFromParams()

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }
      window.addEventListener("keydown", this.handlerAccessDirect);
      this.loadConfigurations()
      this.getIvaCondition()
      this.loadAvailableMethodsPayment()

      this.checkGenerateFromParams()
    },
    computed: {
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentSaleIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrevSale() {
        return this.currentSaleIndex > 0
      },
      canGoNextSale() {
        if(this.currentSaleIndex < 0) {
          return false
        }
        return this.currentSaleIndex < (this.table.items.length - 1)
      },
      filterVoucherTypeOptions() {
        return [{ value: null, text: 'Todos los tipos' }].concat(
          this.arr.filters.types_vouchers.map(typeVoucher => ({
            value: typeVoucher.id,
            text: typeVoucher.name
          }))
        )
      },

      // MODULES
      moduleSellersActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.VENDEDORES) {
            status = true
          }
        })
        return status
      },
      showContabilidad() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.CONTABILIDAD) {
            status = true
          }
        })
        return status
      },
      showRemits() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.REMITOS) {
            status = true
          }
        })
        return status
      },

      // OTHERS
      subtotalItemSelected() {
        if(this.itemSelected) {
          return parseFloat(this.itemSelected.amount_total)
        } else {
          return 0
        }
      },

      // CONDITIONS SELECT
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPointsSalesActive() {
        return [{field: 'active', condition: true}];
      },
      conditionSuppliersShippingActive(){
        var condition = []
        condition.push({field: 'active', condition: true})
        condition.push({field: 'shipping', condition: true})
        return condition;
      },

      // CANT / CURRENCY
      getCantItemSale() {
        var cant1 = this.crud.form.detailProducts.length
        var cant2 = this.crud.form.detailProductsCompound.length
        var cant3 = this.crud.form.detailServices.length
        var cant4 = this.crud.form.detailConcepts.length

        return parseFloat(cant1 + cant2 + cant3 + cant4)
      },
      getCurrencySale() {
        var currency = 'ARS'
        if(this.crud.form.price_list) {
          if(this.crud.form.price_list.currency) {
            currency = this.crud.form.price_list.currency.code
          }
        }
        return currency
      },

      // VOUCHER
      getRefVoucher() {
        if(this.crud.form.types_vouchers && this.crud.form.points_sales && this.crud.form.number) {
          return this.crud.form.types_vouchers.name + ' '  + this.crud.form.points_sales.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.number.toString().padStart(8,'0')
        } else {
          return ''
        }
      },

      // CONFIGURACION
      getCurrency() {
        return 'ARS'
      },

      // INVOICE DESDE
      invoiceFrom() {
        var status = false
        if(this.crud.form.remits_id) {
          status = true
        }
        if(this.crud.form.orders_id) {
          status = true
        }
        if(this.crud.form.budget_id) {
          status = false
        }
        if(this.crud.form.disabled) {
          status = true
        }
        return status
      },

      // VALUES DEFAULT
      customersDefault() {
        if(this.configurations) {
          return parseInt(this.configurations[1].value_number);
        } else {
          return 0;
        }
      },
      activeReceipts() {
        if(this.configurations) {
          return this.configurations[4].value_boolean;
        } else {
          return false;
        }
      },
      notEditPrice() {
        if(this.configurations) {
          return this.configurations[5].value_boolean;
        } else {
          return false;
        }
      },
      showShipping() {
        if(this.configurations) {
          return this.configurations[6].value_boolean
        } else {
          return false
        }
      },
      disabledDates() {
        if(this.configurations) {
          return this.configurations[7].value_boolean
        } else {
          return false
        }
      },
      showTimeMetrics() {
        if(this.configurations) {
          return this.configurations[8].value_boolean
        } else {
          return false
        }
      },

      showMethodPaymentOptions() {
        return this.availableMethodPaymentCount > 1
      },

      devolutionForConcepts() {
        if(this.configurations) {
          return this.configurations[12].value_boolean
        } else {
          return false
        }
      },

      previousDays() {
        if(this.configurations) {
          return this.configurations[13].value_number
        } else {
          return false
        }
      },

      // REMITO
      generateRemits() {
        let result = 'default'
        if(this.configurations) {
          if(this.configurations[2].value_string == 'always-remit') {
            result = 'si';
          }
          if(this.configurations[2].value_string == 'never-remit') {
            result = 'no';
          }
        }
        return result
      },

      // IVA
      showCheckNotIva() {
        let status = false
        let codeAfipRI = 1 // Responsable Inscripto

        const haveNotIva = this.parameters.haveNotIva

        const pointsSales = this.crud.form.points_sales ? this.crud.form.points_sales : null
        const business = pointsSales ? pointsSales.business : null

        if(haveNotIva && business) {
          if(
            (business.fiscal_conditions_id == codeAfipRI && pointsSales.nd) ||
            (business.fiscal_conditions_id != codeAfipRI)
          ) {
            status = true
          }
        }

        return status;
      }
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_sales', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      },
      'crud.form.customers_id': function (newQuestion, oldQuestion) {
        this.searchVoucherByCustomer()

        if(this.crud.form.selectDestination == 'discounts') {
          this.obtenerVouchersPendingImputarByCustomers()
          this.calc.discounts = 0
        }
      },
      'crud.form.points_sales_id': function (newQuestion, oldQuestion) {
        this.searchVoucherByCustomer()

        if(this.crud.form.selectDestination == 'discounts') {
          this.obtenerVouchersPendingImputarByCustomers()
          this.calc.discounts = 0
        }
      },
      'crud.form.concepts_id': function (newQuestion, oldQuestion) {
        if(this.crud.form.selectDestination == 'discounts') {
          this.obtenerVouchersPendingImputarByCustomers()
          this.calc.discounts = 0
        }
      },
      'crud.form.price_list_id': function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.forceUpdateItemDetail()
        }
      },
      'crud.form.disable_customer_price_list_fallback': function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.forceUpdateItemDetail()
        }
      },
      'crud.form.detailProducts': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailProductsCompound': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailServices': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailConcepts': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.not_iva': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'filters.points_sales': function () {
        this.filterLoadVoucherTypes()
      }
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Function.avatarFromName(name)
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el dropdown de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      // Resalta en la tabla la fila del registro que está abierto en el
      // drawer, para no perder la referencia visual mientras se navega con
      // los botones anterior/siguiente.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },

      // CONFIGURACION
      loadFieldTable () {
        // TABLE COMPROBANTES
        this.table.fields = []
        this.table.fields.push({key: 'business', label: 'Empresa', class:"align-middle " + this.alignClass('text-left'), width:"60px"})
        this.table.fields.push({key: 'id', label: 'Comprobante', sortable: true, class:"align-middle " + this.alignClass('text-center'), width:"170px"})
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-center'), width:"80px"})
        this.table.fields.push({key: 'date_expiration', label: 'Vto', class:"align-middle " + this.alignClass('text-center'), width:"80px"})
        this.table.fields.push({key: 'customers_id', label: 'Cliente', class:"align-middle", width:"200px"})

        if(this.moduleSellersActive){
          this.table.fields.push({key: 'sellers_id', label: 'Vend', class:"align-middle " + this.alignClass('text-center'), width:"60px"})
        }

        this.table.fields.push({key: 'staff_id', label: 'Staff', class:"align-middle " + this.alignClass('text-center'), width:"60px"})
        this.table.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.table.fields.push({key: 'amount_pending', label: 'Pendiente', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        this.table.fields.push({key: 'observations_internal', label: this.isMobileViewport ? 'Observaciones Internas' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})

        if(this.showShipping){
          this.table.fields.push({key: 'shipping_id', label: this.isMobileViewport ? 'Transportista' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        }

        if(!this.isMobileViewport) {
          this.table.fields.push({key: 'f_action', label:'', class:"align-middle", width:"60px"})
        }

        // TABLE DETALLE (drawer)
        this.tableSub.fields = []
        this.tableSub.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle", width:"50px"})
        this.tableSub.fields.push({key: 'code', label: 'Código', class:"align-middle", width:"80px"})
        this.tableSub.fields.push({key: 'product', label: 'Item', class:"align-middle", width:"150px"})

        // TABLE DETALLE COMPLETO
        this.tableDetail.fields = []
        this.tableDetail.fields.push({key: 'product', label: 'Item', class:"align-middle " + this.alignClass('text-left'), width:"240px"})
        this.tableDetail.fields.push({key: 'list', label: 'Lista', class:"align-middle " + this.alignClass('text-left') + " text-truncate", width:"50px"})
        this.tableDetail.fields.push({key: 'quantity', label: 'Cant', class:"align-middle " + this.alignClass('text-right'), width:"60px"})
        this.tableDetail.fields.push({key: 'unit_price', label: 'P.Unit', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'subtotal', label: 'Subtotal', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_discount', label: 'Desc', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_net', label: 'P.Neto', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_iva', label: 'IVA', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Devolución' : '', class:"align-middle " + this.alignClass('text-right'), width:"50px"})

        // TABLE ASIENTO
        this.tableAccounting.fields = []
        this.tableAccounting.fields.push({key: 'code', label: 'Código', class:"align-middle", width:"150px"})
        this.tableAccounting.fields.push({key: 'name', label: 'Nombre', class:"align-middle", width:"250px"})
        this.tableAccounting.fields.push({key: 'debit', label: 'Debe', class:"align-middle", width:"150px"})
        this.tableAccounting.fields.push({key: 'credit', label: 'Haber', class:"align-middle", width:"150px"})

        // TABLE IMPUTACIONES
        this.tableImputation.fields = []
        this.tableImputation.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-left'), width:"20%"})
        this.tableImputation.fields.push({key: 'reference', label: 'Referencia', class:"align-middle " + this.alignClass('text-left') + " text-truncate", width:"50%"})
        this.tableImputation.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"30%"})

        // TABLE IMPUTACIONES (drawer, siempre vertical: alineación fija a la izquierda)
        this.tableSubImputation.fields = []
        this.tableSubImputation.fields.push({key: 'date', label: 'Fecha', class:"align-middle text-left", width:"20%"})
        this.tableSubImputation.fields.push({key: 'reference', label: 'Referencia', class:"align-middle text-left text-truncate", width:"50%"})
        this.tableSubImputation.fields.push({key: 'amount_total', label: 'Total', class:"align-middle text-left", width:"30%"})
      },
      loadConfigurations() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data
          this.configurations = data

          this.loadFieldTable()
          this.filterLoad()
          this.filterSales()
          this.showStaff()
        })
      },
      getRowCount (items) {
        return items.length
      },

      // SELECT
      loadCustomers (object) {
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id

          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.points_sales_id) {
                this.crud.form.points_sales = object.data_fiscal.points_sales
                this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
              }
            }

            if(object.data_fiscal.methods_payment_id) {
              if(!this.crud.form.methods_payment_id) {
                this.crud.form.methods_payment = object.data_fiscal.methods_payment
                this.crud.form.methods_payment_id = object.data_fiscal.methods_payment_id

                let days = parseInt(object.data_fiscal.methods_payment.term)
                this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
              }
            }

            if(object.data_fiscal.methods_acopio_id) {
              if(!this.crud.form.methods_acopio_id) {
                this.crud.form.methods_acopio = object.data_fiscal.methods_acopio
                this.crud.form.methods_acopio_id = object.data_fiscal.methods_acopio_id
              }
            }

            if(object.data_fiscal.shipping_id) {
              if(!this.crud.form.shipping_id) {
                this.crud.form.shipping = object.data_fiscal.shipping
                this.crud.form.shipping_id = object.data_fiscal.shipping_id
              }
            }
          }

          if(!this.crud.form.price_list_id) {
            if(!this.crud.form.disable_customer_price_list_fallback && object.price_list) {
              if(object.price_list.list) {
                this.crud.form.price_list = object.price_list.list
                this.crud.form.price_list_id = object.price_list.list.id
                this.crud.form.disable_customer_price_list_fallback = false
              }
            }
          }

          this.getBalanceCurrentAccount()
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
          this.crud.form.disable_customer_price_list_fallback = false

          this.balanceCurrentAccount = 0
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id

          // Resetear not_iva y solo cargarlo si el check debe mostrarse
          this.crud.form.not_iva = false
          // Los computed properties se evalúan síncronamente, no necesitamos $nextTick
          if(this.showCheckNotIva) {
            this.crud.form.not_iva = object.not_iva
          }

          this.getBalanceCurrentAccount()
          this.getFinancesCash()
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0
          this.crud.form.not_iva = false

          this.getBalanceCurrentAccount()
        }
      },
      loadMethodsPayment (object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id

          let days = parseInt(object.term)
          this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
        } else {
          this.crud.form.methods_payment = null
          this.crud.form.methods_payment_id = 0
        }
      },
      loadMethodsAcopio (object) {
        if(object){
          this.crud.form.methods_acopio = object
          this.crud.form.methods_acopio_id = object.id
        } else {
          this.crud.form.methods_acopio = null
          this.crud.form.methods_acopio_id = 0
        }
      },
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id
          this.crud.form.disable_customer_price_list_fallback = false
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
          this.crud.form.disable_customer_price_list_fallback = true
        }
      },
      loadConcepts(object) {
        if(object){
          this.crud.form.concepts = object
          this.crud.form.concepts_id = object.id
        } else {
          this.crud.form.concepts = null
          this.crud.form.concepts_id = 0
        }
      },
      loadShipping (object, source='add') {
        if(source == 'add') {
          if(object){
            this.crud.form.shipping = object
            this.crud.form.shipping_id = object.id
          } else {
            this.crud.form.shipping = null
            this.crud.form.shipping_id = 0
          }
        } else if(source == 'edit') {
          if(object){
            this.crud.shipping.shipping = object
            this.crud.shipping.shipping_id = object.id
          } else {
            this.crud.shipping.shipping = null
            this.crud.shipping.shipping_id = 0
          }
        }
      },
      prepareExport(data) {
        this.arr.export = []
        data.forEach(element => {
          var businessID = 0
          var businessName = ""
          var customersID = 0
          var customersCode = ""
          var customersName = ""
          var methodsPaymentID = 0
          var methodsPaymentName = ""
          var voucherReference = ""
          var currencyID = 0
          var currencyName = ""
          var methodsAcopioID = 0
          var methodsAcopioName = ""

          if(element.point_sale && element.point_sale.business) {
            businessID = element.point_sale.business.id
            businessName = element.point_sale.business.reference
          }
          if(element.customer) {
            customersID = element.customer.id
            customersCode = element.customer.code
            customersName = element.customer.name
          }
          if(element.method_payment) {
            methodsPaymentID = element.method_payment.id
            methodsPaymentName = element.method_payment.name
          }
          if(element.currency) {
            currencyID = element.currency.id
            currencyName = element.currency.name
          }
          if(element.method_acopio) {
            methodsAcopioID = element.method_acopio.id
            methodsAcopioName = element.method_acopio.name
          }
          if(element.type_voucher) {
            voucherReference = element.type_voucher.name + ' ' + element.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.number.toString().padStart(8,'0')
          }

          this.arr.export.push({
            id: element.id,
            businessID: businessID,
            businessName: businessName,
            date: element.date,
            date_expiration: element.date_expiration,
            voucherReference: voucherReference,
            customersID: customersID,
            customersCode: customersCode,
            customersName: customersName,
            methodsPaymentID: methodsPaymentID,
            methodsPaymentName: methodsPaymentName,
            methodsAcopioID: methodsAcopioID,
            methodsAcopioName: methodsAcopioName,
            currencyID: currencyID,
            currencyName: currencyName,
            percentage: element.percentage_discount.replace('.',','),
            discount: element.amount_discount.replace('.',','),
            iva: element.amount_iva.replace('.',','),
            total: element.amount_total.replace('.',','),
            observations: element.observations,
            observations_internal: element.observations_internal,
            productID: 0,
            productCode: "",
            productName: "",
            serviceID: 0,
            serviceCode: "",
            serviceName: "",
            conceptID: 0,
            conceptName: "",
            productCompoundID: 0,
            productCompoundName: "",
            priceListID: 0,
            priceListName: "",
            quantity: 0,
            unitMeasurementID: 0,
            unitMeasurementName: "",
            unit_price: 0,
            surcharge: 0,
            unit_price_surcharge: 0,
            amount_net: 0,
            amount_discount: 0,
            amount_iva: 0,
            amount_total: 0,
          })

          element.details.forEach(element1 => {
            var productID = 0
            var productCode = ""
            var productName = ""
            var serviceID = 0
            var serviceCode = ""
            var serviceName = ""
            var conceptID = 0
            var conceptName = ""
            var productCompoundID = 0
            var productCompoundName = ""
            var unitMeasurementID = 0
            var unitMeasurementName = ""
            var priceListID = 0
            var priceListName = ""

            if(element1.products_id && element1.product) {
              productID = element1.product.id
              productCode = element1.product.code
              productName = element1.product.name
            }

            if(element1.products_colors_id && element1.products_color) {
              productID = element1.products_color.id
              productCode = element1.products_color.code
              productName = element1.products_color.name + " (" + element1.products_color.color.name + ")"
            }

            if(element1.products_waist_id && element1.products_waist) {
              productID = element1.products_waist.id
              productCode = element1.products_waist.code
              productName = element1.products_waist.name + " (" + element1.products_waist.waist.name + ")"
            }

            if(element1.products_color_waist_id && element1.products_color_waist) {
              productID = element1.products_color_waist.id
              productCode = element1.products_color_waist.code
              productName = element1.products_color_waist.name + " (" + element1.products_color_waist.color.name + " - " + element1.products_color_waist.waist.name + ")"
            }

            if(element1.services_id && element1.service) {
              serviceID = element1.service.id
              serviceCode = element1.service.code
              serviceName = element1.service.name
            }

            if(element1.concepts_id && element1.concept) {
              conceptID = element1.concept.id
              conceptName = element1.concept.name
            }

            if(element1.products_compound_id && element1.products_compound) {
              productCompoundID = element1.products_compound.id
              productCompoundName = element1.products_compound.name
            }

            if(element1.unit_measurement_id && element1.unit_measurement) {
              unitMeasurementID = element1.unit_measurement.id
              unitMeasurementName = element1.unit_measurement.name
            }

            if(element1.price_list_id && element1.price_list) {
              priceListID = element1.price_list.id
              priceListName = element1.price_list.name
            } else {
              if(element.price_list_id && element.price_list) {
                priceListID = element.price_list.id
                priceListName = element.price_list.name
              }
            }

            this.arr.export.push({
              productID: productID,
              productCode: productCode,
              productName: productName,
              serviceID: serviceID,
              serviceCode: serviceCode,
              serviceName: serviceName,
              conceptID: conceptID,
              conceptName: conceptName,
              productCompoundID: productCompoundID,
              productCompoundName: productCompoundName,
              priceListID: priceListID,
              priceListName: priceListName,
              quantity: element1.quantity.replace('.',','),
              unitMeasurementID: unitMeasurementID,
              unitMeasurementName: unitMeasurementName,
              unit_price: element1.price_unit.replace('.',','),
              surcharge: element1.surcharge ? element1.surcharge.replace('.',',') : '0',
              unit_price_surcharge: element1.price_surcharge.toString().replace('.',','),
              amount_net: element1.amount_net.replace('.',','),
              amount_discount: element1.amount_discount.replace('.',','),
              amount_iva: element1.amount_iva.replace('.',','),
              amount_total: element1.amount_total.replace('.',','),
            })
          })
        });
      },

      // Repite en activated() lo que mounted() solo revisa una vez -- si la
      // pestaña ya estaba montada (keep-alive, mismo fullPath que una
      // invocación anterior, ej. "Facturar" dos veces seguidas sobre el
      // mismo pedido/remito/presupuesto), "mounted" no vuelve a correr y
      // ninguna de estas acciones "Facturar desde X" abriría el formulario
      // una segunda vez sin repetir acá el mismo chequeo.
      checkGenerateFromParams() {
        var triggered = false
        var generationOrigin = null

        this.crud.form.orders_id = this.$route.params.ordersID
        if(this.crud.form.orders_id) {
          this.invoiceFromOrders()
          generationOrigin = { type: 'orders' }
          triggered = true
        }

        this.crud.form.remits_id = this.$route.params.remitsID
        if(this.crud.form.remits_id) {
          this.invoiceFromRemits()
          generationOrigin = { type: 'remits' }
          triggered = true
        }

        this.crud.form.budget_id = this.$route.params.budgetID
        if(this.crud.form.budget_id) {
          let amountImpute = 0

          if(this.$route.query.amount_impute){
            amountImpute = this.$route.query.amount_impute
          }

          this.invoiceFromBudget(amountImpute)
          generationOrigin = { type: 'budget' }
          triggered = true
        }

        if(this.$route.query.budgetsIDs) {
          this.crud.form.budget_ids = this.$route.query.budgetsIDs
          this.invoiceFromMultipleBudgets(this.$route.query.budgetsIDs.split(','))
          triggered = true
        }

        this.crud.form.services_customer_id = this.$route.params.serviceCustomerID
        if(this.crud.form.services_customer_id) {
          if(this.$route.query) {
            this.invoiceFromServiceCustomer(this.$route.query)
          }
          generationOrigin = { type: 'services' }
          triggered = true
        }

        this.crud.form.projects_id = this.$route.params.projectsID
        if(this.crud.form.projects_id) {
          if(this.$route.query) {
            this.invoiceFromProjects(this.$route.query)
          }
          generationOrigin = { type: 'projects', id: this.crud.form.projects_id }
          triggered = true
        }

        // Acción directa desde la paleta de comandos: abrir el alta al
        // entrar (query.type: 'factura' por defecto, o
        // 'notacredito'/'notadebito').
        if (this.$route.query.new == '1') {
          this.add(this.$route.query.type || 'factura')
          triggered = true
        }

        // Vuelve a la ruta simple apenas se consume cualquiera de estos
        // triggers -- si no, la pestaña queda con el pedido/remito/
        // presupuesto/etc. pegado en la URL para siempre y volver a ella
        // (activated, keep-alive) dispararía todo de nuevo aunque el
        // usuario solo quiera ver el listado.
        if (triggered) {
          this.generationOrigin = generationOrigin
          this.$router.replace({ name: 'SalesStaffSales' }).catch(() => {})
        } else {
          this.generationOrigin = null
        }
      },

      // INVOICE FROM ORDERS / REMITS / BUDGET / SERVICES / PROJECTS
      invoiceFromOrders() {
        var result = serviceAPI.mostrarPedido(this.crud.form.orders_id);
        result.then((response) => {
          var data = response.data

          if(data.sale_id) {
            this.$awn.alert("El pedido ya se encuentra facturado");
            return false
          }

          this.add('factura','default')

          setTimeout(()=>{
            this.crud.form.orders = data
            this.crud.form.customers_id = data.customers_id
            this.crud.form.customers = data.customer
            this.crud.form.points_sales_id = data.erp_points_sales_id
            this.crud.form.points_sales = data.points_sales
            this.crud.form.methods_payment_id = data.methods_payment_id
            this.crud.form.methods_payment = data.method_payment
            this.crud.form.price_list_id = data.price_list_id
            this.crud.form.price_list = data.price_list
            this.crud.form.percentage_discount = data.percentage_discount

            if(this.generateRemits == 'default') {
              this.crud.form.generateRemits = true
            } else {
              if(this.generateRemits == 'si') {
                this.crud.form.generateRemits = true
              } else if (this.generateRemits == 'no') {
                this.crud.form.generateRemits = false
              }
            }

            if(data.details) {
              data.detail.forEach(element => {
                if(element.product) {
                  this.crud.form.detailProducts.push(element)
                }
              })
            }
          },1000)
        })
        .catch(error => {
          // blanqueo invoice from
          this.crud.form.orders_id = 0
          this.crud.form.orders = null

          this.$awn.alert(Error.showError(error));
        })
      },
      invoiceFromRemits() {
        var result = serviceAPI.mostrarRemito(this.crud.form.remits_id);
        result.then((response) => {
          var data = response.data

          if(data.sale_id) {
            this.$awn.alert("El remito ya se encuentra facturado");
            return false
          }

          this.add('factura','default')

          setTimeout(()=>{
            this.crud.form.remits = data
            this.crud.form.customers_id = data.customers_id
            this.crud.form.customers = data.customer
            this.crud.form.points_sales_id = data.points_sales_id
            this.crud.form.points_sales = data.point_sale

            if(data.details[0] && data.details[0].orders_detail && data.details[0].orders_detail.order) {
              var order = data.details[0].orders_detail.order

              this.crud.form.methods_payment_id = order.methods_payment_id
              this.crud.form.methods_payment = order.method_payment
              this.crud.form.price_list_id = order.price_list_id
              this.crud.form.price_list = order.price_list

              data.detail.forEach(element => {
                if(element.product) {
                  this.crud.form.detailProducts.push(element)
                }
              })
            }
          },1000)
        })
        .catch(error => {
          // blanqueo invoice from
          this.crud.form.remits_id = 0
          this.crud.form.remits = null

          this.$awn.alert(Error.showError(error));
        })
      },
      creditNoteFromSalesDetail(sale_id) {
        this.modal.devolution.wait = true
        let loader = this.$loading.show();

        var result = serviceAPI.mostrarComprobante(sale_id);
        result.then((response) => {
          var data = response.data

          this.add('notacredito','default', false)

          setTimeout(()=>{
            this.crud.form.customers_id = data.customers_id
            this.crud.form.customers = data.customer
            this.crud.form.points_sales_id = data.points_sales_id
            this.crud.form.points_sales = data.point_sale
            this.crud.form.methods_payment_id = data.methods_payment_id
            this.crud.form.methods_payment = data.method_payment
            this.crud.form.price_list_id = data.price_list_id
            this.crud.form.price_list = data.price_list
            this.crud.form.percentage_discount = data.percentage_discount
            this.crud.form.disabled = false

            if(data.detail) {
              data.detail.forEach(element => {
                if(this.crud.formDevolutionLote.enable) {

                  var addItem = false
                  this.crud.formDevolutionLote.data.forEach(element1 => {
                    if(element.itemDetail.id == element1.id) {
                      addItem = element1.check
                    }
                  });

                  if(addItem) {
                    if(element.product) {
                      if(parseFloat(element.itemDetail.quantity_remit)) {
                        element.quantity = parseFloat(element.itemDetail.quantity_remit)
                      } else {
                        element.quantity = parseFloat(element.itemDetail.quantity)
                      }
                      this.crud.form.detailProducts.push(element)
                    }
                    if(element.productCompound) {
                      if(parseFloat(element.itemDetail.quantity_remit)) {
                        element.quantity = parseFloat(element.itemDetail.quantity_remit)
                      } else {
                        element.quantity = parseFloat(element.itemDetail.quantity)
                      }
                      this.crud.form.detailProductsCompound.push(element)
                    }

                    // devuelvo conceptos
                    if(this.devolutionForConcepts) {
                      if(element.concepts) {
                        if(parseFloat(element.itemDetail.quantity_remit)) {
                          element.quantity = parseFloat(element.itemDetail.quantity_remit)
                        } else {
                          element.quantity = parseFloat(element.itemDetail.quantity)
                        }
                        this.crud.form.detailConcepts.push(element)
                      }
                    }
                    // fin
                  }
                } else {
                  if(this.crud.formDevolution.sale_detail.products_id == element.itemDetail.products_id &&
                    this.crud.formDevolution.sale_detail.products_colors_id == element.itemDetail.products_colors_id &&
                    this.crud.formDevolution.sale_detail.products_waist_id == element.itemDetail.products_waist_id &&
                    this.crud.formDevolution.sale_detail.products_color_waist_id == element.itemDetail.products_color_waist_id) {

                    if(element.product && element.itemDetail.id ==  this.crud.formDevolution.sale_detail_id) {
                      element.quantity = this.crud.formDevolution.quantity
                      this.crud.form.detailProducts.push(element)
                    }
                    if(element.productCompound && element.itemDetail.id ==  this.crud.formDevolution.sale_detail_id) {
                      element.quantity = this.crud.formDevolution.quantity
                      this.crud.form.detailProductsCompound.push(element)
                    }

                    // devuelvo conceptos
                    if(this.devolutionForConcepts) {
                      if(element.concepts && element.itemDetail.id ==  this.crud.formDevolution.sale_detail_id) {
                        element.quantity = this.crud.formDevolution.quantity
                        this.crud.form.detailConcepts.push(element)
                      }
                    }
                    // fin

                    if(this.crud.form.detailProducts.length>0 || this.crud.form.detailProductsCompound.length>0) {
                      if(!parseFloat(this.crud.formDevolution.quantity)) {
                        this.$awn.alert('La cantidad a devolver debe ser mayor a 0')
                        this.modal.devolution.wait = false
                        this.cancel(true)
                        return false
                      }

                      if(parseFloat(element.itemDetail.quantity) == parseFloat(element.itemDetail.quantity_remit)) {
                        if(parseFloat(this.crud.formDevolution.quantity)>parseFloat(element.itemDetail.quantity)) {
                          this.$awn.alert('La cantidad a devolver no puede ser mayor a la cantidad total')
                          this.modal.devolution.wait = false
                          this.cancel(true)
                          return false
                        }
                      }

                      if(parseFloat(element.itemDetail.quantity) > parseFloat(element.itemDetail.quantity_remit)) {
                        if(parseFloat(this.crud.formDevolution.quantity) > (parseFloat(element.itemDetail.quantity) - parseFloat(element.itemDetail.quantity_remit))) {
                          this.$awn.alert('La cantidad a devolver no puede ser mayor a la cantidad pendiente')
                          this.modal.devolution.wait = false
                          this.cancel(true)
                          return false
                        }
                      }
                    }
                  }
                }
              })

              setTimeout(()=>{
                this.crud.form.invoiceRelated.push({
                  amount: this.totals.total_surcharge,
                  reference: data.type_voucher.name + ' ' + data.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.number.toString().padStart(8,'0'),
                  voucher: data,
                })
                this.forceUpdateItem()

                if(Function.toFixed(this.totals.total_surcharge,2) > Function.toFixed(parseFloat(data.amount_total) - parseFloat(data.amount_impute),2)) {
                  this.$awn.alert('El monto a devolver no puede ser mayor al monto imputado')
                  this.modal.devolution.wait = false
                  this.cancel(true)
                  return false
                }
              },2000)
            }
          },1000)

          loader.hide()
          this.modal.devolution.wait = false
        })
        .catch(error => {
          loader.hide()

          // blanqueo invoice from
          this.crud.form.disabled = false

          this.modal.devolution.wait = false
          this.$awn.alert(Error.showError(error));
        })
      },
      invoiceFromBudget(amountImpute) {
        var result = serviceAPI.mostrarPresupuesto(this.crud.form.budget_id);
        result.then((response) => {
          var data = response.data

          if(data.sale_id) {
            this.$awn.alert("El presupuesto ya se encuentra facturado");
            return false
          }

          this.add('factura','default')

          setTimeout(()=>{
            this.crud.form.budget = data
            this.crud.form.customers_id = data.customers_id
            this.crud.form.customers = data.customer
            this.crud.form.points_sales_id = data.points_sales_id
            this.crud.form.points_sales = data.point_sale
            this.crud.form.methods_payment_id = data.methods_payment_id
            this.crud.form.methods_payment = data.method_payment
            this.crud.form.price_list_id = data.price_list_id
            this.crud.form.price_list = data.price_list
            this.crud.form.percentage_discount = data.percentage_discount

            if(data.detail) {
              data.detail.forEach(element => {
                if(element.product) {
                  this.crud.form.detailProducts.push(element)
                }
                if(element.service) {

                  if(amountImpute) {
                    this.crud.form.isBudgetStage = true
                    this.crud.form.budgetAmountImpute = amountImpute

                    element.price = amountImpute
                    element.quantity = 1
                  } else {
                    this.crud.form.isBudgetStage = false
                    this.crud.form.budgetAmountImpute = 0
                  }

                  this.crud.form.detailServices.push(element)
                }
                if(element.concepts) {
                  this.crud.form.detailConcepts.push(element)
                }
              })
            }

            this.forceUpdateItemDetail()
          },1000)
        })
        .catch(error => {
          // blanqueo invoice from
          this.crud.form.budget_id = 0
          this.crud.form.budget = null
          this.crud.form.isBudgetStage = false
          this.crud.form.budgetAmountImpute = 0

          this.$awn.alert(Error.showError(error));
        })
      },
      invoiceFromMultipleBudgets(ids) {
        if(!ids || ids.length === 0) return

        var firstBudgetId = ids[0]
        var result = serviceAPI.mostrarPresupuesto(firstBudgetId)

        result.then((response) => {
          var firstData = response.data

          if(firstData.sale_id) {
            this.$awn.alert("El presupuesto #" + firstBudgetId + " ya se encuentra facturado")
            return false
          }

          this.add('factura','default')

          setTimeout(() => {
            this.crud.form.budget = firstData
            this.crud.form.budgets_list = [firstData]
            this.crud.form.customers_id = firstData.customers_id
            this.crud.form.customers = firstData.customer
            this.crud.form.points_sales_id = firstData.points_sales_id
            this.crud.form.points_sales = firstData.point_sale
            this.crud.form.methods_payment_id = firstData.methods_payment_id
            this.crud.form.methods_payment = firstData.method_payment
            this.crud.form.price_list_id = firstData.price_list_id
            this.crud.form.price_list = firstData.price_list
            this.crud.form.percentage_discount = firstData.percentage_discount

            var addDetails = (data) => {
              if(data.detail) {
                data.detail.forEach(element => {
                  if(element.product) {
                    this.crud.form.detailProducts.push(element)
                  }
                  if(element.concepts) {
                    this.crud.form.detailConcepts.push(element)
                  }
                })
              }
            }

            addDetails(firstData)

            var remainingIds = ids.slice(1)
            var fetchNext = (index) => {
              if(index >= remainingIds.length) {
                this.forceUpdateItemDetail()
                return
              }
              var nextId = remainingIds[index]
              serviceAPI.mostrarPresupuesto(nextId).then((res) => {
                var nextData = res.data
                if(!nextData.sale_id) {
                  this.crud.form.budgets_list.push(nextData)
                  addDetails(nextData)
                }
                fetchNext(index + 1)
              }).catch(error => {
                this.$awn.alert(Error.showError(error))
              })
            }

            fetchNext(0)
          }, 1000)
        })
        .catch(error => {
          this.crud.form.budget_ids = ''
          this.$awn.alert(Error.showError(error))
        })
      },
      invoiceFromServiceCustomer(data) {
        this.add('factura','default')

        setTimeout(()=>{
          this.crud.form.customers_id = parseInt(data.customers_id)
          this.crud.form.customers = JSON.parse(data.customers)
          this.crud.form.points_sales_id = 0
          this.crud.form.points_sales = null
          this.crud.form.methods_payment_id = 0
          this.crud.form.methods_payment = null
          this.crud.form.price_list_id = 0
          this.crud.form.price_list = null
          this.crud.form.disable_customer_price_list_fallback = true
          this.crud.form.percentage_discount = 0

          if(data.detail) {
            JSON.parse(data.detail).forEach(element => {
              this.crud.form.detailServices.push(element)
            })
          }

          this.forceUpdateItemDetail()
        },1000)
      },
      invoiceFromProjects(data) {
        this.add('factura','default')

        setTimeout(()=>{
          this.crud.form.customers_id = parseInt(data.customers_id)
          this.crud.form.customers = JSON.parse(data.customers)
          this.crud.form.points_sales_id = 0
          this.crud.form.points_sales = null
          this.crud.form.methods_payment_id = 0
          this.crud.form.methods_payment = null
          this.crud.form.price_list_id = 0
          this.crud.form.price_list = null
          this.crud.form.disable_customer_price_list_fallback = true
          this.crud.form.percentage_discount = 0

          if(data.detail) {
            JSON.parse(data.detail).forEach(element => {
              this.crud.form.detailServices.push(element)
            })
          }

          this.forceUpdateItemDetail()
        },1000)
      },

      // AMOUNT CURRENT ACCOUNT
      getBalanceCurrentAccount() {
        var result = serviceAPI.filtrarCurrentsAccountsBalance({
          customers_id: this.crud.form.customers_id,
          points_sales_id: this.crud.form.points_sales_id,
        })

        result.then((response) => {
          var data = response.data
          this.balanceCurrentAccount = data
        })
      },

      // ABM MAIN
      add(type = 'factura', destination = 'default', loadCustomerDefault = true) {
        this.crud.form._idempotency_key = crypto.randomUUID()
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment().add(10,'d').format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.observations_internal = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0

        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        if(loadCustomerDefault && this.customersDefault) {
          this.crud.form.customers_id = this.customersDefault
        }

        this.crud.form.points_sales_id = 0
        this.crud.form.points_sales = null
        this.crud.form.methods_payment_id = 0
        this.crud.form.methods_payment = null
        this.crud.form.price_list_id = 0
        this.crud.form.price_list = null
        this.crud.form.disable_customer_price_list_fallback = false
        this.crud.form.concepts_id = 0
        this.crud.form.concepts = null
        this.crud.form.percentage_discount = 0
        this.crud.form.detailProducts = []
        this.crud.form.detailProductsCompound = []
        this.crud.form.detailServices = []
        this.crud.form.detailConcepts = []
        this.crud.form.invoiceRelated = []
        this.crud.form.methods_acopio_id = 0
        this.crud.form.methods_acopio = null
        this.crud.form.customer_name = ''
        this.crud.form.customer_document_number = ''
        this.crud.form.shipping_id = 0
        this.crud.form.shipping = null

        this.crud.form.not_iva = false

        this.crud.form.payment = []
        this.financesForceUpdate()

        if(this.showRemits) {
          if(this.generateRemits == 'default') {
            this.crud.form.generateRemits = false
          } else {
            if(this.generateRemits == 'si') {
              this.crud.form.generateRemits = true
            } else if (this.generateRemits == 'no') {
              this.crud.form.generateRemits = false
            }
          }
        } else {
          if(this.generateRemits == 'default') {
            this.crud.form.generateRemits = true
          } else {
            if(this.generateRemits == 'si') {
              this.crud.form.generateRemits = true
            } else if (this.generateRemits == 'no') {
              this.crud.form.generateRemits = false
            }
          }
        }

        this.balanceCurrentAccount = 0

        if(type=='factura' && destination=='default')
          this.modal.form.title = "Nueva Factura"

        if(type=='notadebito' && destination=='default')
          this.modal.form.title = "Nueva Nota de Débito"

        if(type=='notacredito' && destination=='default')
          this.modal.form.title = "Nueva Nota de Crédito"

        if(type=='notacredito' && destination=='discounts')
          this.modal.discounts.title = "Nueva Nota de Crédito (Descuentos en Facturas)"

        this.crud.form.selectTypeVoucher = type
        this.crud.form.selectDestination = destination

        if(destination=='default') {
          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.active = true
        }

        if(destination=='discounts') {
          this.modal.discounts._id = Math.random().toString(36).slice(2, 8)
          this.modal.discounts.active = true
        }
      },
      remove(item) {
        this.crud.form.id = item.id

        var voucher = "ID #" + item.id
        if(item.type_voucher && item.point_sale) {
          voucher = item.type_voucher.name + ' ' + item.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')
        }

        this.confirmDialog('¿Desea borrar el comprobante ' + voucher + '?', {
          title: 'Borrar Comprobante',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarComprobante(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              if(this.itemSelected && this.itemSelected.id === this.crud.form.id) {
                this.hideSub()
              }
              loader.hide()
              this.filterSales()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      preSave() {
        if(this.activeReceipts) {
          if(this.crud.form.selectTypeVoucher != 'notacredito') {
            this.saveAndPayment()
          } else {
            this.save()
          }
        } else {
          this.save()
        }
      },

      save() {
        if (this.isSaving) return;

        this.crud.form.isSaveConfirmActive = true

        this.confirmDialog('¿Desea continuar con la generación del comprobante?', {
          title: 'Generar Comprobante',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            this.isSaving = true;
            let loader = this.$loading.show();

            var result = null
            if (this.crud.form.id) {
              result = serviceAPI.editarComprobante(this.crud.form);
            } else {
              result = serviceAPI.agregarComprobante(this.crud.form);
            }

            result.then((response) => {
              var data = response.data
              this.sendPrinterSale(data)

              this.modal.form.active = false
              this.modal.discounts.active = false

              this.modal.payment.active = false
              this.finances.resetControl = true

              // blanqueo invoice from
              this.crud.form.remits_id = 0
              this.crud.form.remits = null
              this.crud.form.orders_id = 0
              this.crud.form.orders = null
              this.crud.form.budget_id = 0
              this.crud.form.budget = null
              this.crud.form.isBudgetStage = false
              this.crud.form.budgetAmountImpute = 0
              this.crud.form.services_customer_id = 0
              this.crud.form.projects_id = 0
              this.crud.form.disabled = false
              this.modal.devolution.active = false
              this.modal.detail.active = false

              loader.hide()
              this.isSaving = false;
              this.crud.form.isSaveConfirmActive = false
              this.filterSales()
              this.$awn.success("Comprobante generado con éxito");

              this.returnToGenerationOrigin()
            })
            .catch(error => {
              loader.hide()
              this.isSaving = false;
              this.crud.form.isSaveConfirmActive = false
              this.crud.form._idempotency_key = crypto.randomUUID()
              this.$awn.alert(Error.showError(error));
            })
          } else {
            this.crud.form.isSaveConfirmActive = false
          }
        })
        .catch(error => {
          this.crud.form.isSaveConfirmActive = false

          this.$awn.alert(Error.showError(error));
        })
      },
      cancel(force=false) {
        if(force) {
          this.modal.form.active = false
          this.modal.discounts.active = false

          // blanqueo invoice from
          this.crud.form.remits_id = 0
          this.crud.form.remits = null
          this.crud.form.orders_id = 0
          this.crud.form.orders = null
          this.crud.form.budget_id = 0
          this.crud.form.budget = null
          this.crud.form.isBudgetStage = false
          this.crud.form.budgetAmountImpute = 0
          this.crud.form.services_customer_id = 0
          this.crud.form.projects_id = 0
          this.crud.form.disabled = false
        } else {
          this.confirmDialog('¿Desea cancelar el comprobante?', {
            title: 'Cancelar el Comprobante',
            icon: 'warning',
            danger: true,
            okTitle: 'SI',
            cancelTitle: 'NO'
          })
          .then(value => {
            if (value) {
              this.modal.form.active = false
              this.modal.discounts.active = false

              // blanqueo invoice from
              this.crud.form.remits_id = 0
              this.crud.form.remits = null
              this.crud.form.orders_id = 0
              this.crud.form.orders = null
              this.crud.form.budget_id = 0
              this.crud.form.budget = null
              this.crud.form.isBudgetStage = false
              this.crud.form.budgetAmountImpute = 0
              this.crud.form.services_customer_id = 0
              this.crud.form.projects_id = 0
              this.crud.form.disabled = false

              this.returnToGenerationOrigin()
            }
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error));
          })
        }
      },
      setDetailItems(event, type) {
        if(type=="products") {
          this.crud.form.detailProducts = event
        }
        if(type=="productsCompound") {
          this.crud.form.detailProductsCompound = event
        }
        if(type=="services") {
          this.crud.form.detailServices = event
        }
        if(type=="concepts") {
          this.crud.form.detailConcepts = event
        }
      },

      // STORE FINANCES
      saveAndPayment() {
        this.finances.resetControl = true

        this.modal.payment.title = "Detalle del pago"
        this.modal.payment.active = true
      },
      getFinancesCash() {
        serviceAPI.obtenerCajas().then((response) => {
          const data = response.data;
          this.arr.financesCash = [];

          const freeMode = this.parameters.freeAddTypeOperation;
          const formPS = this.crud.form.points_sales || {};
          const userCashId = this.finances.staff && this.finances.staff.cash_id;
          const pointCashId = formPS.cash_id;
          const formNd = formPS.nd;

          // Validación ND (si no está en modo libre)
          const isValidND = (cash) => {
            return freeMode || (cash.nd === formNd);
          };

          // 1. Agregar la caja del usuario si la tiene y pasa validación
          if (userCashId) {
            const userCash = data.find(cash => cash.id === userCashId && isValidND(cash));
            if (userCash) this.arr.financesCash.push(userCash);
          }

          // 2. Si no hay caja de usuario, agregar la del punto de venta si pasa validación
          if (!userCashId && pointCashId) {
            const pointCash = data.find(cash => cash.id === pointCashId && isValidND(cash));
            if (pointCash) this.arr.financesCash.push(pointCash);
          }

          // 3. Agregar cajas compartidas que pasen validación
          data.forEach(cash => {
            if (cash.shared && isValidND(cash)) {
              // Evitar duplicados si ya se agregó
              const exists = this.arr.financesCash.find(c => c.id === cash.id);
              if (!exists) this.arr.financesCash.push(cash);
            }
          });

          // 4. Si no hay caja de usuario ni del punto de venta, agregar todas que pasen validación
          if (!userCashId && !pointCashId) {
            data.forEach(cash => {
              if (isValidND(cash)) {
                const exists = this.arr.financesCash.find(c => c.id === cash.id);
                if (!exists) this.arr.financesCash.push(cash);
              }
            });
          }
        });
      },
      transformFinances(id) {
        this.financesForceUpdate()

        setTimeout(()=>{
          if(this.totals.total_surcharge) {
            let cash = this.arr.financesCash.find(cash => parseInt(cash.keyaccess) === parseInt(id));

            if(cash) {
              let cash_id = cash.id

              let item = {
                cash: {
                  detail: [
                    {
                      cash: cash,
                      cash_id: cash_id,
                      total: this.totals.total_surcharge,
                    },
                  ],
                  total: this.totals.total_surcharge,
                },
                cheques: {
                  detail: null,
                  total: 0,
                },
                total: this.totals.total_surcharge,
                totalFormat: Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrency}).format(this.totals.total_surcharge),
              }

              this.finances.resetControl = true
              this.finances.default = item

              this.$awn.info("PAGO CON: <b>" + cash.name + '</b> - <b>' + item.totalFormat + '</b>');

              this.storeFinances(item)
            } else {
              this.$awn.warning("Caja/Banco <b>NO DISPONIBLE</b>");
            }
          }
        },100)
      },
      storeFinances(values) {
        this.crud.form.payment = values
        this.crud.form.payment.totalFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencySale}).format(this.crud.form.payment.total)

        this.finances.resetControl = false
      },
      cancelPayment() {
        this.modal.payment.active=false
      },
      financesForceUpdate() {
        this.finances.forceUpdate = this.finances.forceUpdate + 1
      },
      showStaff()  {
        let staffID = Helper.getStaffId()
        var result = serviceAPI.mostrarStaff(staffID)

        result.then((response) => {
          var data = response.data
          if(data) {
            this.finances.staff = data
          } else {
            this.finances.staff = null
          }
        })
      },

      // CALC
      getPendingVoucherSale(item) {
        return parseFloat(item.amount_total) - parseFloat(item.amount_impute)
      },

      // VALID
      saleValidCrudGeneral() {
        this.searchTotalsTemporary()

        if(this.crud.form.customers_id && this.crud.form.points_sales_id  && this.crud.form.methods_payment_id) {
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }
          if(!this.crud.form.methods_payment_id) {
            this.$awn.alert("No se cargó el método de pago");
            return false;
          }
        }
      },
      saleValidCrudDetail() {
        if( this.crud.form.detailProducts.length ||
            this.crud.form.detailProductsCompound.length ||
            this.crud.form.detailServices.length ||
            this.crud.form.detailConcepts.length) {
          this.getContabilidad()
          return true;
        } else {
          this.$awn.alert("No se cargó ningún item");
          return false;
        }
      },
      saleValidCrudRelation() {
        var sum = 0
        if(this.crud.form.invoiceRelated.length) {
          this.crud.form.invoiceRelated.forEach(element => {
            sum = parseFloat(sum) + parseFloat(element.amount)
          });

          if(parseFloat(sum.toFixed(2)) != parseFloat(this.totals.total_surcharge.toFixed(2))) {
            this.$awn.alert("Falta imputar comprobantes");
            return false;
          } else {
            return true
          }
        } else {
          this.$awn.alert("Es obligatorio vincular una o mas factura a una nota de crédito o débito");
          return false;
        }
      },
      salesValidCrudAccounting() {
        if(this.crud.form.accountingEntry) {
          return true
        } else {
          this.$awn.alert("Revisar el Asiento Contable");
          return false
        }
      },

      // VALID DESC (NC)
      saleValidCrudGeneralDiscounts() {
        if(this.crud.form.customers_id && this.crud.form.points_sales_id && this.crud.form.concepts_id) {
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }
          if(!this.crud.form.concepts_id) {
            this.$awn.alert("No se cargó el concepto");
            return false;
          }
        }
      },
      saleValidCrudImputationDiscounts() {
        if(this.calc.discounts>0) {
          this.setVouchersPendingDiscounts()
          this.getContabilidad()
          return true;
        } else {
          this.$awn.alert("No puede continuar sin aplicar descuentos");
          return false;
        }
      },

      // INVOICE RELACIONADA EN NC (DISCOUNTS)
      obtenerVouchersPendingImputarByCustomers() {
        this.crud.formPending = []

        if(this.crud.form.customers_id && this.crud.form.points_sales_id) {
          var result = serviceAPI.filtrarPendienteImputar({
            customers_id:this.crud.form.customers_id,
            points_sales_id: this.crud.form.points_sales_id,
            hide_note_credit: true,
          })
          result.then((response) => {
            var data = response.data

            this.arr.pending = data
            this.arr.pending.forEach(element => {
              this.crud.formPending.push({
                check: false,
                id: element.id,
                discounts: 0,
                amount: 0,
                amount_total: 0,
                amountPending: parseFloat(element.amount_total) - parseFloat(element.amount_impute),
                amountNet: parseFloat(element.amount_net),
                maxAmount: parseFloat(element.amount_total) - parseFloat(element.amount_impute),
                operation: element.type_voucher.type_balance,
                voucher: element,
              })
            });
          })
        }
      },
      calcVoucherPending(item) {
        return parseFloat(item.amount_total) - parseFloat(item.amount_impute)
      },
      validCheck(index) {
        if(this.crud.formPending[index].check) {
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount = 0
          this.crud.formPending[index].amount_total = 0
          this.forceUpdateItem()
        }

        this.getAmountDiscounts()
      },
      validAmount(index){
        if(this.crud.formPending[index].discounts=='') {
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount = 0
          this.crud.formPending[index].amount_total = 0
          this.crud.formPending[index].check = false
        }

        var aliquot = 0
        if(this.crud.form.concepts && this.crud.form.concepts.iva_conditions) {
          aliquot = this.crud.form.concepts.iva_conditions.aliquot
        }

        var calcDiscounts = (parseFloat(this.crud.formPending[index].amountNet) * parseFloat(this.crud.formPending[index].discounts)) / 100
        var calcDiscountsTotal = calcDiscounts + ((calcDiscounts * aliquot) / 100)

        this.crud.formPending[index].amount = parseFloat(calcDiscounts).toFixed(2)
        this.crud.formPending[index].amount_total = parseFloat(calcDiscountsTotal).toFixed(2)
        this.forceUpdateItem()

        if( parseFloat(calcDiscountsTotal) > parseFloat(this.crud.formPending[index].maxAmount)) {
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount = 0
          this.crud.formPending[index].amount_total = 0
          this.crud.formPending[index].check = false
          this.$awn.alert("El descuento no puede ser mayor al total pendiente de imputación");
          this.forceUpdateItem()
        }

        if( parseFloat(this.crud.formPending[index].amount_total) < 0) {
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount = 0
          this.crud.formPending[index].amount_total = 0
          this.crud.formPending[index].check = false
          this.$awn.alert("No es posible un descuento menor a cero");
          this.forceUpdateItem()
        }

        if( parseFloat(this.crud.formPending[index].amount_total) == 0) {
          this.crud.formPending[index].discounts = 0
          this.crud.formPending[index].amount = 0
          this.crud.formPending[index].amount_total = 0
          this.crud.formPending[index].check = false
          this.forceUpdateItem()
        }

        this.getAmountDiscounts()
      },
      getAmountDiscounts() {
        var discounts = 0
        if(this.crud.formPending) {
          this.crud.formPending.forEach(element => {
            if(element.check) {
              if(element.operation == '+') {
                discounts = parseFloat(discounts) + parseFloat(element.amount_total)
              } else {
                discounts = parseFloat(discounts) - parseFloat(element.amount_total)
              }
            }
          });
        }
        this.calc.discounts = discounts
      },
      setVouchersPendingDiscounts() {
        // cargo el concepto del descuento
        this.crud.form.detailConcepts = []
        this.crud.form.detailConcepts.push({
          id: this.crud.form.concepts.id,
          concepts: this.crud.form.concepts,
          quantity: 1,
          price: parseFloat(this.calc.discounts),
          description: this.crud.form.concepts.name,
        })

        var subtotal = 0
        var total = 0
        this.crud.form.invoiceRelated = []
        this.aux.detailConcepts = []
        if(this.crud.formPending) {
          this.crud.formPending.forEach(element => {
            if(element.check && parseFloat(element.amount_total)>0) {
              // cargo las facturas relacionadas con la nota de credito
              this.crud.form.invoiceRelated.push({
                voucher: element.voucher,
                reference: element.voucher.type_voucher.name + ' ' + element.voucher.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.voucher.number.toString().padStart(8,'0'),
                amount: element.amount_total,
              })

              // cargo el auxilar del concepto para los asientos contables
              this.aux.detailConcepts.push({
                quantity: 1,
                price: parseFloat(element.amount),
                iva: parseFloat(element.amount_total) - parseFloat(element.amount),
                concepts: this.crud.form.concepts,
              })

              // totalizadores
              subtotal = subtotal + parseFloat(element.amount)
              total = total + parseFloat(element.amount_total)
            }
          })
        }

        // cargo los totales
        this.totals.subtotal = Function.toFixed(subtotal,2)
        this.totals.discount = 0
        this.totals.iva = Function.toFixed(total,2) - Function.toFixed(subtotal,2)
        this.totals.total = Function.toFixed(total,2)

        // cargo el iva
        this.totals.arrIva = []
        this.totals.arrIva[this.crud.form.concepts.iva_conditions_id] = this.totals.iva
      },
      forceUpdateItem() {
        this.itemForceUpdate = this.itemForceUpdate + 1
      },
      forceUpdateItemDetail() {
        this.itemForceUpdateDetail = this.itemForceUpdateDetail + 1
      },

      // SELECT VOUCHER
      searchVoucherByCustomer() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherByCustomer({
              'customers_id': this.crud.form.customers_id,
              'point_sale_id': this.crud.form.points_sales_id,
              'reference': this.crud.form.selectTypeVoucher,
            });
            result.then((response) => {
              this.crud.form.types_vouchers_id = response.data[0].id
              this.searchVoucher()
            })
            .catch(error => {
              this.$awn.alert(Error.showError(error));
            })
          }
        } else {
          if( this.crud.form.types_vouchers ) {
            // simple
            var titleVoucher = ''
            titleVoucher = titleVoucher + this.crud.form.types_vouchers.name
            titleVoucher = titleVoucher +  ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            titleVoucher = titleVoucher +  '-' + this.crud.form.number.toString().padStart(8,'0')

            if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
              if(this.crud.form.points_sales.status) {
                if(this.crud.form.points_sales.afip_production) {
                  this.modal.form.title = titleVoucher + ' (CONECTADO ARCA)'
                } else {
                  this.modal.form.title = titleVoucher + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                }
              } else {
                this.modal.form.title = titleVoucher + ' (DESCONECTADO ARCA)'
              }
            } else {
              this.modal.form.title = titleVoucher
            }

            // nc discounts
            var titleDiscounts = ''
            titleDiscounts = titleDiscounts + this.crud.form.types_vouchers.name
            titleDiscounts = titleDiscounts + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            titleDiscounts = titleDiscounts + '-' + this.crud.form.number.toString().padStart(8,'0')

            if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
              if(this.crud.form.points_sales.status) {
                if(this.crud.form.points_sales.afip_production) {
                  this.modal.discounts.title = titleDiscounts + ' (CONECTADO ARCA)'
                } else {
                  this.modal.discounts.title = titleDiscounts + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                }
              } else {
                this.modal.discounts.title = titleDiscounts + ' (DESCONECTADO ARCA)'
              }
            } else {
              this.modal.discounts.title = titleDiscounts
            }
          }
        }
      },
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherById({
              'points_sales_id': this.crud.form.points_sales_id,
              'types_vouchers_id' : this.crud.form.types_vouchers_id,
            });
            result.then((response) => {
              this.crud.form.types_vouchers = response.data.type_voucher
              this.crud.form.letter = response.data.type_voucher.letter
              this.crud.form.number = response.data.number

              if( this.crud.form.types_vouchers ) {
                // simple
                var titleVoucher = ''
                titleVoucher = titleVoucher + this.crud.form.types_vouchers.name
                titleVoucher = titleVoucher +  ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
                titleVoucher = titleVoucher +  '-' + this.crud.form.number.toString().padStart(8,'0')

                if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
                  if(this.crud.form.points_sales.status) {
                    if(this.crud.form.points_sales.afip_production) {
                      this.modal.form.title = titleVoucher + ' (CONECTADO ARCA)'
                    } else {
                      this.modal.form.title = titleVoucher + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                    }
                  } else {
                    this.modal.form.title = titleVoucher + ' (DESCONECTADO ARCA)'
                  }
                } else {
                  this.modal.form.title = titleVoucher
                }

                // nc discounts
                var titleDiscounts = ''
                titleDiscounts = titleDiscounts + this.crud.form.types_vouchers.name
                titleDiscounts = titleDiscounts + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
                titleDiscounts = titleDiscounts + '-' + this.crud.form.number.toString().padStart(8,'0')

                if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
                  if(this.crud.form.points_sales.status) {
                    if(this.crud.form.points_sales.afip_production) {
                      this.modal.discounts.title = titleDiscounts + ' (CONECTADO ARCA)'
                    } else {
                      this.modal.discounts.title = titleDiscounts + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                    }
                  } else {
                    this.modal.discounts.title = titleDiscounts + ' (DESCONECTADO ARCA)'
                  }
                } else {
                  this.modal.discounts.title = titleDiscounts
                }
              }
            })
          }
        } else {
          if( this.crud.form.types_vouchers ) {
            // simple
            var titleVoucher = ''
            titleVoucher = titleVoucher + this.crud.form.types_vouchers.name
            titleVoucher = titleVoucher +  ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            titleVoucher = titleVoucher +  '-' + this.crud.form.number.toString().padStart(8,'0')

            if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
              if(this.crud.form.points_sales.status) {
                if(this.crud.form.points_sales.afip_production) {
                  this.modal.form.title = titleVoucher + ' (CONECTADO ARCA)'
                } else {
                  this.modal.form.title = titleVoucher + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                }
              } else {
                this.modal.form.title = titleVoucher + ' (DESCONECTADO ARCA)'
              }
            } else {
              this.modal.form.title = titleVoucher
            }

            // nc discounts
            var titleDiscounts = ''
            titleDiscounts = titleDiscounts + this.crud.form.types_vouchers.name
            titleDiscounts = titleDiscounts + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            titleDiscounts = titleDiscounts + '-' + this.crud.form.number.toString().padStart(8,'0')

            if(this.crud.form.points_sales && !this.crud.form.points_sales.nd) {
              if(this.crud.form.points_sales.status) {
                if(this.crud.form.points_sales.afip_production) {
                  this.modal.discounts.title = titleDiscounts + ' (CONECTADO ARCA)'
                } else {
                  this.modal.discounts.title = titleDiscounts + ' (CONECTADO ARCA - HOMOLOGACIÓN)'
                }
              } else {
                this.modal.discounts.title = titleDiscounts + ' (DESCONECTADO ARCA)'
              }
            } else {
              this.modal.discounts.title = titleDiscounts
            }
          }
        }
      },
      searchTotalsTemporary() {
        if(this.crud.form.detailProducts || this.crud.form.detailProductsCompound || this.crud.form.detailServices || this.crud.form.detailConcepts) {
          var result = serviceAPI.obtenerVoucherTotalsTemporary({
            'header': this.crud.form,
            'detailsProducts': this.crud.form.detailProducts,
            'detailsProductsCompound': this.crud.form.detailProductsCompound,
            'detailsServices': this.crud.form.detailServices,
            'detailsConcepts': this.crud.form.detailConcepts,
            'methods_payment': this.crud.form.methods_payment,
          });
          result.then((response) => {
            var data = response.data

            this.aux.detailProducts = data.detailProducts
            this.aux.detailProductsCompound = data.detailProductsCompound
            this.aux.detailServices = data.detailServices
            this.aux.detailConcepts = data.detailConcepts

            this.totals.subtotal = data.amount_net
            this.totals.discount = data.amount_discount
            this.totals.subtotal_discount = data.amount_subtotal
            this.totals.iva = data.amount_iva
            this.totals.total = data.amount_total
            this.totals.total_surcharge = data.amount_total_surcharge
            this.totals.arrIva = data.arrIva
          })
        }
      },
      validDiscounts() {
        if(this.crud.form.percentage_discount=='') {
          this.crud.form.percentage_discount = 0
        } else {
          if( parseFloat(this.crud.form.percentage_discount) < 0 ||
              parseFloat(this.crud.form.percentage_discount) > 100 ) {
            this.crud.form.percentage_discount = 0
          }
        }
        this.searchTotalsTemporary()
      },

      // INVOICE RELACIONADA EN NC
      getInvoiceRelated(event) {
        this.crud.form.invoiceRelated = event
      },

      // FILTER
      filterLoad() {
        this.filterLoadCustomers()
        this.filterLoadSellers()
        this.filterLoadPointSale()
        this.filterLoadShipping()
        this.filters.date_start = moment().subtract(this.previousDays, 'days').format('YYYY-MM-DD')
        this.filters.date_end = moment().format('YYYY-MM-DD')

        this.restoreFilterStorage()
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()
        result.then((response) => {
          var data = response.data

          this.arr.filters.customers = []
          data.forEach(element => {
            if(element.code) {
              this.arr.filters.customers.push({ code: element.id, label: element.code + ' | ' + element.name })
            } else {
              this.arr.filters.customers.push({ code: element.id, label: element.name })
            }
          });
        })
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()
        result.then((response) => {
          var data = response.data

          this.arr.filters.sellers = []
          data.forEach(element => {
            this.arr.filters.sellers.push({ code: element.id, label: element.name })
          });
        })
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()
        result.then((response) => {
          var data = response.data

          this.arr.filters.points_sales = []
          data.forEach(element => {
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })
          });

          this.filterLoadVoucherTypes()
        })
      },
      filterLoadVoucherTypes() {
        var pointSaleIds = this.filters.points_sales
          ? [this.filters.points_sales.code]
          : this.arr.filters.points_sales.map(pointSale => pointSale.code)

        if(!pointSaleIds.length) {
          this.arr.filters.types_vouchers = []
          return
        }

        var result = serviceAPI.obtenerTiposComprobantesPermitidos({ point_sale_ids: pointSaleIds })
        result.then((response) => {
          this.arr.filters.types_vouchers = response.data

          if(this.filters.types_vouchers_id && !this.arr.filters.types_vouchers.some(typeVoucher => typeVoucher.id == this.filters.types_vouchers_id)) {
            this.filters.types_vouchers_id = null
          }
        })
      },
      filterLoadShipping() {
        var result = serviceAPI.obtenerShipping()
        result.then((response) => {
          var data = response.data

          this.arr.filters.shipping = []
          data.forEach(element => {
            if(element.shipping) {
              this.arr.filters.shipping.push({ code: element.id, label: element.name })
            }
          });
        })
      },

      filterSales(forceOpenSub=false) {
        this.saveFilterStorage()

        this.table.isBusy = true
        var result = serviceAPI.filtrarComprobante(this.filters, this.table.currentPage)
        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data
          this.arr.sales = data.data
          this.prepareExport(data.data)

          this.table.items.forEach(element => {
            if(forceOpenSub && this.itemSelected && element.id == this.itemSelected.id) {
              this.openSub(element)
            }

            if((element.amount_total != element.amount_impute) && element.type_voucher.type_balance=='+') {
              element._rowVariant = 'warning'
            }
          });

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error));
        })
      },
      filterSalesMetrics() {
        this.saveFilterStorage()
        this.filterForceUpdate()
      },
      filterForceUpdate() {
        this.itemFilterForceUpdate = this.itemFilterForceUpdate + 1
      },

      // COMPROBANTE DETAIL
      openSub(item) {
        this.itemSelected = item

        this.tableSub.items = item.details
        this.loadImputations(item)
        this.detailDrawer = true
      },
      hideSub() {
        this.tableSub.items=[]
        this.itemSelected = null
        this.detailDrawer = false
      },
      // Anterior/siguiente desde el drawer: reusa openSub() con el vecino,
      // así el contenido y el resaltado de fila se actualizan por el mismo
      // camino que un click directo en la tabla.
      goPrevSale() {
        if(!this.canGoPrevSale) return
        var item = this.table.items[this.currentSaleIndex - 1]
        if(item) this.openSub(item)
      },
      goNextSale() {
        if(!this.canGoNextSale) return
        var item = this.table.items[this.currentSaleIndex + 1]
        if(item) this.openSub(item)
      },
      openDetail() {
        this.tableDetail.items = this.itemSelected.details
        this.creditNotesDetails = []

        this.crud.formDevolutionLote.enable = false
        this.crud.formDevolutionLote.showButton = false
        this.crud.formDevolutionLote.data = []
        this.tableDetail.items.forEach((element,index) => {
          this.crud.formDevolutionLote.data[index] = []
          this.crud.formDevolutionLote.data[index]['id'] = element.id
          this.crud.formDevolutionLote.data[index]['check'] = false
        });

        if(this.itemSelected.accounting_entries){
          if(this.itemSelected.accounting_entries.details){
            this.tableAccounting.items = this.itemSelected.accounting_entries.details
          } else {
            this.tableAccounting.items = []
          }
        } else {
          this.tableAccounting.items = []
        }

        this.modal.detail._id = Math.random().toString(36).slice(2, 8)
        this.modal.detail.title = "Detalle del Comprobante"
        this.modal.detail.active = true

        if(this.itemSelected.type_voucher && this.itemSelected.type_voucher.type_balance == '+') {
          const saleId = this.itemSelected.id
          serviceAPI.obtenerNotasCreditoDetalle(saleId)
            .then(response => {
              if(this.itemSelected && this.itemSelected.id == saleId) {
                this.creditNotesDetails = response.data || []
              }
            })
            .catch(() => {})
        }
      },
      getDetailCode(item) {
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductCode(item)
        }
        if(item.services_id) {
          return item.service.code
        }
        if(item.concepts_id) {
          return item.concept.code
        }
        if(item.products_compound_id) {
          return item.products_compound.code
        }
      },
      getCreditNoteImpact(detail) {
        const relations = this.creditNotesDetails
        const impact = { quantity: 0, references: [] }

        relations.forEach(relation => {
          const creditNote = relation.sale
          if(!creditNote || !creditNote.type_voucher || creditNote.type_voucher.reference !== 'notacredito' || !creditNote.details) {
            return
          }

          const quantity = creditNote.details
            .filter(creditNoteDetail => this.isSameDetailItem(detail, creditNoteDetail))
            .reduce((total, creditNoteDetail) => total + parseFloat(creditNoteDetail.quantity || 0), 0)

          if(quantity > 0) {
            impact.quantity += quantity
            impact.references.push(this.getCreditNoteReference(creditNote))
          }
        })

        if(impact.quantity <= 0) {
          return null
        }

        impact.quantity = parseFloat(impact.quantity.toFixed(2))
        return impact
      },
      isSameDetailItem(detail, creditNoteDetail) {
        const productFields = [
          'products_id',
          'products_colors_id',
          'products_waist_id',
          'products_color_waist_id',
          'products_compound_id',
        ]
        const hasProduct = productFields.some(field => parseInt(detail[field] || 0) || parseInt(creditNoteDetail[field] || 0))

        if(hasProduct) {
          return productFields.every(field => parseInt(detail[field] || 0) === parseInt(creditNoteDetail[field] || 0))
        }

        if(parseInt(detail.services_id || 0) || parseInt(creditNoteDetail.services_id || 0)) {
          return parseInt(detail.services_id || 0) === parseInt(creditNoteDetail.services_id || 0)
        }

        if(parseInt(detail.concepts_id || 0) || parseInt(creditNoteDetail.concepts_id || 0)) {
          return parseInt(detail.concepts_id || 0) === parseInt(creditNoteDetail.concepts_id || 0)
        }

        return false
      },
      getCreditNoteReference(creditNote) {
        const type = creditNote.type_voucher ? creditNote.type_voucher.name : 'Nota de Crédito'
        const pointSale = creditNote.point_sale && creditNote.point_sale.point_sale !== undefined
          ? String(creditNote.point_sale.point_sale).padStart(4, '0')
          : ''
        const number = creditNote.number !== undefined && creditNote.number !== null
          ? String(creditNote.number).padStart(8, '0')
          : String(creditNote.id)

        return pointSale ? type + ' ' + pointSale + '-' + number : type + ' #' + number
      },
      getDetailName(item) {
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductName(item)
        }
        if(item.services_id) {
          return item.description
        }
        if(item.concepts_id) {
          return item.description
        }
        if(item.products_compound_id) {
          return item.description
        }
      },
      getProductCode(item) {
        var code = ''
        var prod = null

        if(item.code) {
          code = item.code
        }

        if(item.products_id) {
          if(code) {
            return code
          } else {
            return item.product.code
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }
      },
      getProductName(item) {
        var name = ''
        var prod = null

        if(item.description) {
          name = item.description
        }

        if(item.products_id) {
          if(name) {
            return name
          } else {
            return item.product.name
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(name) {
            return name + ' (' + prod.color.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ')'
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(name) {
            return name + ' (' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.waist.name + ')'
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(name) {
            return name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          }
        }
      },

      // IMPUTATIONS
      loadImputations(item) {
        var arrImputations = []
        if(item.receipts) {
          item.receipts.forEach(element => {
            arrImputations.push({
              date: element.receipts.date,
              reference: element.receipts.type_voucher.name + ' ' + element.receipts.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.receipts.number.toString().padStart(8,'0'),
              amount_total: element.amount_total
            })
          });
        }

        if(item.sales_related) {
          item.sales_related.forEach(element => {
            arrImputations.push({
              date: element.sale_related.date,
              reference: element.sale_related.type_voucher.name + ' ' + element.sale_related.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.sale_related.number.toString().padStart(8,'0'),
              amount_total: element.amount_total
            })
          });
        }

        if(item.sales_related_n_c) {
          item.sales_related_n_c.forEach(element => {
            if(element.sale.type_voucher.reference == 'notacredito') {
              arrImputations.push({
                date: element.sale.date,
                reference: element.sale.type_voucher.name + ' ' + element.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.sale.number.toString().padStart(8,'0'),
                amount_total: element.amount_total
              })
            }

            if(element.sale.type_voucher.reference == 'notadebito') {
              arrImputations.push({
                date: element.sale.date,
                reference: element.sale.type_voucher.name + ' ' + element.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.sale.number.toString().padStart(8,'0'),
                amount_total: element.sale.amount_total
              })
            }
          });
        }

        this.tableImputation.items = arrImputations
        this.tableSubImputation.items = arrImputations
      },

      // DEVOLUTION
      showCheckDevolution(item) {
        var status = false
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          status = true
        }
        if(item.concepts_id && this.devolutionForConcepts) {
          status = true
        }
        if(item.products_compound_id) {
          status = true
        }
        return status
      },
      showDevolution(item) {
        if(Function.toFixed(item.amount_impute,2) < Function.toFixed(item.amount_total,2)) {
          return true
        } else {
          return false
        }
      },
      showDevolutionLote() {
        var result = false
        if(this.crud.formDevolutionLote.data) {
          this.crud.formDevolutionLote.data.forEach(element => {
            if(element['check'] == true) {
              result = true
            }
          });
        }
        this.crud.formDevolutionLote.showButton = result
      },
      openDevolution(item) {
        this.modal.devolution.wait = false

        this.crud.formDevolution.sale_id = item.sale_id
        this.crud.formDevolution.sale_detail_id = item.id
        this.crud.formDevolution.sale_detail = item
        this.crud.formDevolution.code = item.code
        this.crud.formDevolution.name = item.description
        this.crud.formDevolution.quantity = parseFloat(item.quantity) - parseFloat(item.quantity_remit)
        this.crud.formDevolution.quantity_pending = parseFloat(item.quantity) - parseFloat(item.quantity_remit)
        this.crud.formDevolution.quantity_total = parseFloat(item.quantity)
        this.crud.formDevolution.unit_measurement = item.unit_measurement

        this.modal.devolution.title = "Devolución de Producto"
        this.modal.devolution.active = true
      },

      // OBSERVACIONES INTERNAS
      openObservations(item) {
        this.itemSelected = item

        this.crud.observations.id = item.id
        this.crud.observations.observations_internal = item.observations_internal

        this.modal.observations.active = true
        this.modal.observations.title = "Edición de Observaciones"
      },
      saveObservations() {
        this.confirmDialog('¿Guardar Observaciones?', {
          title: 'Observaciones',
          okTitle: 'GUARDAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.editarComprobanteCampos(this.crud.observations);

            result.then((response) => {
              this.modal.observations.active = false
              loader.hide()
              this.filterSales()
              this.$awn.success("Observaciones Guardada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // TRANSPORTISTA
      openShipping(item) {
        this.itemSelected = item

        this.crud.shipping.id = item.id
        this.crud.shipping.shipping_id = item.shipping_id
        this.crud.shipping.shipping = item.shipping

        this.modal.shipping.active = true
        this.modal.shipping.title = "Edición de Transportista"
      },
      saveShipping() {
        this.confirmDialog('¿Guardar Transportista?', {
          title: 'Transportista',
          okTitle: 'GUARDAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.editarComprobanteCampos(this.crud.shipping);

            result.then((response) => {
              this.modal.shipping.active = false
              loader.hide()
              this.filterSales()
              this.$awn.success("Transportista Guardado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // ACCESSOS DIRECTOS
      handlerAccessDirect(e) {
        // ctrl + shift + f = 70
        if (e.ctrlKey && e.shiftKey && e.keyCode === 70) {
          e.preventDefault();
          this.add('factura')
        }

        // ctrl + shift + d = 68
        if (e.ctrlKey && e.shiftKey && e.keyCode === 68) {
          e.preventDefault();
          this.add('notadebito')
        }

        // ctrl + shift + d = 67
        if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
          e.preventDefault();
          this.add('notacredito')
        }

        // ctrl + shift + enter = 13
        if(!this.crud.form.isSaveConfirmActive && !this.isSaving) {
          if (e.ctrlKey && e.shiftKey && e.keyCode === 13) {
            e.preventDefault();

            if(this.modal.payment.active) {
              this.save()
            } else {
              if(this.$refs.wizard) {
                this.$refs.wizard.nextTab();
              }
            }
          }
        }

        // f2 = 113
        if(this.modal.form.active) {
          if (e.keyCode === 113) {
            if(this.$refs.searchCustomer) {
              this.$refs.searchCustomer.openSearch()
            }
          }
        }

        // ctrl + shift + number (0-9)
        if(this.modal.payment.active){
          let isKeyNumber = e.code.includes('Numpad') || e.code.includes('Digit')
          let isCtrl = e.ctrlKey
          let isShift = e.shiftKey

          if (isKeyNumber) {
            if(isCtrl || isShift) {
              e.preventDefault();

              let id = parseInt(e.code.slice(-1))
              if(!isNaN(id)) {
                this.transformFinances(id)
              }
            }
          }
        }
      },

      /******************
       * AFIP - ARCA
       *****************/
      showCaeAFIP(item) {
        this.itemSelected = item
        this.crud.formCAE.id = item.id

        if(item.customer && item.customer.data_fiscal && item.customer.data_fiscal.fiscal_conditions_id == 5) {
          if(item.afip_customer_identification) {
            this.crud.formCAE.customer_name = item.afip_customer_identification.name
            this.crud.formCAE.customer_document_number = item.afip_customer_identification.document_number
          }

          this.modal.cae.title = "Obtener CAE"
          this.modal.cae.active = true
        } else {
          this.getCaeAFIP()
        }
      },
      getCaeAFIP() {
        this.confirmDialog('Buscar CAE asignado para el comprobante. ¿Desea Continuar?', {
          title: 'Buscar CAE',
          okTitle: 'BUSCAR'
        })
        .then(value => {
          if (value) {
            this.modal.cae.active = false

            let loader = this.$loading.show();

            var result = serviceAPI.getCAEComprobante(this.crud.formCAE);

            result.then((response) => {
              loader.hide()
              this.filterSales()
              this.$awn.success("CAE guardado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.filterSales()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // RECARGO METODO DE PAGO
      loadAvailableMethodsPayment() {
        var result = serviceAPI.obtenerMetodosPagos()
        result.then((response) => {
          var data = Array.isArray(response.data) ? response.data : []
          this.availableMethodPaymentCount = data.length
        })
        .catch(() => {
          this.availableMethodPaymentCount = 0
        })
      },
      showSurchargeMethodPayment() {
        this.modal.method_payment.title = "Métodos de Pago Disponibles"
        this.modal.method_payment.active = true
      },
      setMethodPayment(object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id

          let days = parseInt(object.term)
          this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
        }

        this.searchTotalsTemporary()
        this.modal.method_payment.active=false
      },

      // PRINT
      sendPrinterSale(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
        this.crud.print.reference = item.reportDefault
        this.crud.print.mode = item.print_mode || 'pdf'
      },

      /****************
       * CONTABILIDAD *
       * **************/
      getContabilidad() {
        if(this.showContabilidad) {
          this.contabilidad.render = false
          this.contabilidad.typeDebe = ""
          this.contabilidad.typeHaber = "",
          this.contabilidad.defaultDebe = []
          this.contabilidad.defaultHaber = []
          this.contabilidad.reference = this.getRefVoucher
          this.contabilidad.amountTotal = parseFloat(this.totals.total_surcharge)

          // ASIENTO POR DEFECTO
          if( this.crud.form.selectTypeVoucher == 'factura' ||
              this.crud.form.selectTypeVoucher == 'notadebito') {
            this.contabilidad.defaultDebe = this.getContabilidadAsientoVenta('debe')
            this.contabilidad.defaultHaber = this.getContabilidadAsientoVenta('haber')
          }
          if(this.crud.form.selectTypeVoucher == 'notacredito') {
            this.contabilidad.defaultDebe = this.getContabilidadAsientoCredito('debe')
            this.contabilidad.defaultHaber = this.getContabilidadAsientoCredito('haber')
          }
          // END

          this.contabilidad.render = true
          this.forceUpdate()
        }
      },

      getAsiento(object) {
        this.crud.form.accountingEntry = object
      },
      forceUpdate() {
        this.itemAccountingForceUpdate = this.itemAccountingForceUpdate + 1
      },

      getIvaCondition() {
        var result = serviceAPI.obtenerCondicionesIva()
        result.then((response) => {
          var data = response.data
          this.arr.ivaCondition = data
        })
      },

      getContabilidadAsientoVenta(type) {
        if(type == 'debe') {

          var arrDebe = []

          var totalConcepts = 0
          if(this.aux.detailConcepts) {
            this.aux.detailConcepts.forEach(element => {
              totalConcepts = totalConcepts + parseFloat(element.price) + parseFloat(element.iva)

              arrDebe.push(
                {
                  account: element.concepts.accounting_account_default,
                  amount: parseFloat(element.price) + parseFloat(element.iva),
                  disabled: true,
                }
              )
            });
          }

          if( parseFloat(this.totals.total_surcharge) > totalConcepts ) {
            arrDebe.push(
              {
                account: this.crud.form.customers.accounting_account_default,
                amount: parseFloat(this.totals.total_surcharge) - totalConcepts,
                disabled: true,
              }
            )
          }

          return arrDebe
        }

        if(type == 'haber') {
          var arrHaber = [
            {
              account: this.crud.form.customers.accounting_account_secondary,
              amount: parseFloat(this.totals.total_surcharge) - parseFloat(this.totals.iva),
              disabled: true,
            }
          ]

          if(this.totals.arrIva) {
            Object.entries(this.totals.arrIva).forEach(([index1, element1]) => {
              this.arr.ivaCondition.forEach(element2 => {
                if(index1 == element2.id) {
                  arrHaber.push({
                    account: element2.accounting_account_default,
                    amount: parseFloat(element1),
                    disabled: true,
                  })
                }
              });
            })

          }

          return arrHaber
        }
      },
      getContabilidadAsientoCredito(type) {
        if(type == 'debe') {
          var arrDebe = [
            {
              account: this.crud.form.customers.accounting_account_secondary,
              amount: parseFloat(this.totals.total_surcharge) - parseFloat(this.totals.iva),
              disabled: true,
            }
          ]

          if(this.totals.arrIva) {
            Object.entries(this.totals.arrIva).forEach(([index1, element1]) => {
              this.arr.ivaCondition.forEach(element2 => {
                if(index1 == element2.id) {
                  arrDebe.push({
                    account: element2.accounting_account_default,
                    amount: parseFloat(element1),
                    disabled: true,
                  })
                }
              });
            })

          }

          return arrDebe
        }

        if(type == 'haber') {

          var arrHaber = []

          var totalConcepts = 0
          if(this.aux.detailConcepts) {
            this.aux.detailConcepts.forEach(element => {
              totalConcepts = totalConcepts + parseFloat(element.price) + parseFloat(element.iva)

              arrHaber.push(
                {
                  account: element.concepts.accounting_account_default,
                  amount: parseFloat(element.price) + parseFloat(element.iva),
                  disabled: true,
                }
              )
            });
          }

          if( parseFloat(this.totals.total_surcharge) > totalConcepts ) {
            arrHaber.push(
              {
                account: this.crud.form.customers.accounting_account_default,
                amount: parseFloat(this.totals.total_surcharge) - totalConcepts,
                disabled: true,
              }
            )
          }

          return arrHaber
        }
      },

      /****************
       * RETORNO *
       * **************/
      returnToGenerationOrigin() {
        var origin = this.generationOrigin

        // Compatibilidad con una navegación que todavía conserve el parámetro
        // en la URL. Normalmente checkGenerateFromParams() ya la limpia.
        if (!origin) {
          if (this.$route.params.ordersID) origin = { type: 'orders' }
          else if (this.$route.params.remitsID) origin = { type: 'remits' }
          else if (this.$route.params.budgetID) origin = { type: 'budget' }
          else if (this.$route.params.serviceCustomerID) origin = { type: 'services' }
          else if (this.$route.params.projectsID) origin = { type: 'projects', id: this.$route.params.projectsID }
        }

        this.generationOrigin = null
        if (!origin) return

        if (origin.type == 'orders') this.goOrders()
        else if (origin.type == 'remits') this.goRemits()
        else if (origin.type == 'budget') this.goBudget()
        else if (origin.type == 'services') this.goServices()
        else if (origin.type == 'projects') this.goProjects(origin.id)
      },
      goOrders() {
        this.$router.push({ name: 'OrdersStaffCrudOrders' })
      },
      goRemits() {
        this.$router.push({ name: 'RemitsStaffRemits' })
      },
      goBudget()  {
        this.$router.push({ name: 'BudgetsStaffCrudBudget' })
      },
      goServices()  {
        this.$router.push({ name: 'ServicesStaffDisplayServicesCustomers' })
      },
      goProjects(id)  {
        this.$router.push({ name: 'ProjectStaffDetailHoursProjects', params: {
          projectID: id
        } })
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_crud_sales', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_crud_sales')) {
          this.filters = Object.assign({}, this.filters, JSON.parse(Storage.getValue('filter_crud_sales')))
        }
      },

    }
  }
</script>
<style>
  .crud-sales-view-tabs .nav-link {
    padding: 8px 6px;
  }
  .crud-sales-view-tabs > .col-auto {
    padding-left: 2px;
    padding-right: 2px;
  }
  .crud-sales-wizard .wizard-header {
    padding: 0px;
  }
  .crud-sales-item-input {
    height: 25px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .crud-sales-add-total-final {
    font-weight: 800 !important;
    font-size: 15px !important;
    text-align: right;
  }
  .crud-sales-table-items {
    height: 400px;
    overflow: auto;
  }
  .crud_sales_alert_from {
    padding: 5px 10px;
    margin-bottom: 0px;
  }
  .crud-sales-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-sales-stat__label {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .crud-sales-stat__value {
    font-size: 22px;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
  }
  .crud-sales-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-sales-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
    font-size: 12px;
  }
  .crud-sales-totals__row + .crud-sales-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-sales-totals__label {
    color: var(--app-color-text-muted);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-sales-totals__value {
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-sales-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-sales-totals__row--total .crud-sales-totals__label,
  .crud-sales-totals__row--total .crud-sales-totals__value {
    font-size: 14px;
    color: var(--app-color-text);
  }
  .crud-sales-totals__discount-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }
  .crud-sales-totals__discount {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .crud-sales-totals__discount input {
    width: 62px;
    height: 26px;
    padding: 2px 4px;
    text-align: right;
  }
  .crud-sales-totals__discount-suffix {
    color: var(--app-color-text-muted);
    font-size: 12px;
  }
  .crud-sales-item-cell {
    padding: 6px 0;
  }
  .crud-sales-item-cell__code {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    margin-bottom: 2px;
  }
  .crud-sales-item-cell__name {
    line-height: 1.35;
  }
  .sales-detail-credit-note-impact {
    display: flex;
    align-items: flex-start;
    gap: 5px;
    margin-top: 5px;
    padding: 4px 6px;
    border: 1px solid var(--app-color-warning-border);
    border-radius: 4px;
    background: var(--app-color-warning-soft);
    color: var(--app-color-warning-hover);
    font-size: 11px;
    line-height: 1.3;
  }
  .sales-detail-credit-note-impact > span {
    min-width: 0;
  }
  .sales-detail-credit-note-impact small {
    display: block;
    margin-top: 1px;
    color: inherit;
    font-size: 10px;
  }

  #container_consumer_indentification legend {
    padding-bottom: 0px;
    text-align: left;
  }
  .sales-form-modal-dialog {
    max-width: min(1400px, 95vw);
  }
  .sales-detail-devolution-btn {
    min-width: 34px;
    min-height: 34px;
  }
  .sales-devolution-quantity .input-group {
    width: 100%;
  }
  .sales-devolution-quantity {
    width: 50%;
    margin-left: auto;
  }
  .sales-devolution-quantity label {
    display: block;
    text-align: left;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
